$(document).ready(function() {
    // Get product ID from the product-info element or other available sources
    // The getProductId() function will try multiple methods to find the product ID:
    // 1. From data-product-id attribute on product-info elements
    // 2. From URL path if on a product page
    // 3. From product form variant inputs
    // 4. From window.product object
    // 5. From meta tags
    const productId = getProductId();
    console.log('Product ID:', productId);
    
    // API URL for fetching product attributes (using structured-search endpoint)
    const apiProdUrl = `https://socal-biomed-app-mryuw.ondigitalocean.app/api/product/structured-search?product_id=${productId}`;
    console.log('API URL:', apiProdUrl);
    
    // Transform API response to match our expected format
    function transformApiResponse(apiData) {
        if (!apiData || !apiData.product) {
            console.warn('Invalid API response structure');
            return null;
        }

        const product = apiData.product;
        const requiredSteps = product.required?.steps || [];
        const optionalSteps = product.optional?.steps || [];
        
        console.log(`🔄 transformApiResponse: ${requiredSteps.length} required steps, ${optionalSteps.length} optional steps`);
        if (optionalSteps.length > 0) {
            console.log(`   Optional steps:`, optionalSteps.map((s, idx) => ({
                index: idx,
                name: s.attribute?.name,
                isOptionalAccessory: s.attribute?.isOptionalAccessory,
                possibleValues: s.attribute?.possibleValues || s.possibleValues || s.selectedValues || []
            })));
        }
        
        // Combine required and optional steps
        const allSteps = [...requiredSteps, ...optionalSteps];
        console.log(`   Combined total: ${allSteps.length} steps`);
        
        const transformedData = {
            attributeData: allSteps.map((step, index) => {
                const attribute = step.attribute;
                const isOptionalAccessory = !!attribute.isOptionalAccessory;
                // Use ONLY selectedValues from the step, not possibleValues
                // This ensures we only show the values that are actually selected/available in the API response
                const selectedValues = step.selectedValues || [];
                console.log(`📋 Step ${index} (${attribute.name}):`, {
                    isOptionalAccessory,
                    selectedValues,
                    selectedValuesCount: selectedValues.length,
                    attributeName: attribute.name
                });
                return {
                    attributeLevel: attribute.name,
                    attributeType: attribute.type === 'DROPDOWN' ? 'dropdown' : 
                                  attribute.type === 'TOGGLE' ? 'toggle' : 'dropdown',
                    attributeBehaviour: attribute.isRequired
                        ? 'required'
                        : (isOptionalAccessory ? 'optionalAccessory' : 'optional'),
                    isOptionalAccessory,
                    storeTitle: attribute.storeTitle || null,
                    sorting: index,
                    options: selectedValues.map((value, optIndex) => ({
                        key: value,
                        name: value,
                        sorting: optIndex
                    }))
                };
            }),
            // Store variants separately for required and optional
            requiredVariants: product.required?.variants || [],
            optionalVariants: product.optional?.variants || []
        };

        console.log('Transformed API data:', transformedData);
        console.log(`   Total attributes: ${transformedData.attributeData.length}`);
        console.log(`   Attributes:`, transformedData.attributeData.map(a => `${a.attributeLevel} (${a.attributeBehaviour})`));
        return transformedData;
    }

    // Get product name from API data
    function getProductName() {
        if (window.apiProductData && window.apiProductData.product) {
            return window.apiProductData.product.name;
        }
        return 'Product Configuration';
    }

    // Show success message when form is loaded
    function showSuccessMessage() {
        const formContainer = $('#attribute-form-container');
        const successMessage = $(`
            <div class="success-message" style="text-align: center; padding: 15px; margin-bottom: 20px; background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border: 1px solid #c3e6cb; border-radius: 6px; color: #155724;">
                <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
                    </svg>
                    <span style="font-weight: 600;">Configuration loaded successfully! ${sortedAttributes.length} options available.</span>
                </div>
            </div>
        `);
        
        // Insert after the header but before the progress bar
        formContainer.find('.form-header').after(successMessage);
        
        // Auto-hide after 5 seconds
        setTimeout(() => {
            successMessage.fadeOut(500, function() {
                $(this).remove();
            });
        }, 5000);
    }

    // Global variables for attributes and form data
    let attributeData = null;
    let sortedAttributes = [];
    let isLoading = false;
    let currentAbortController = null; // Store current request's AbortController to cancel if needed
    let isInitializing = false; // Prevent multiple concurrent initializations
    let isUpdatingAvailability = false; // Flag to prevent recursive calls

    /**
     * Ensure optional attributes are always placed after required ones.
     * Preserves original ordering within each group by the provided sorting key.
     */
    function sortAttributesWithOptionalLast(attributes = []) {
        const required = attributes
            .filter(attr => attr.attributeBehaviour === 'required')
            .sort((a, b) => a.sorting - b.sorting);
        const optional = attributes
            .filter(attr => attr.attributeBehaviour === 'optional')
            .sort((a, b) => a.sorting - b.sorting);
        const optionalAccessory = attributes
            .filter(attr => attr.attributeBehaviour === 'optionalAccessory')
            .sort((a, b) => a.sorting - b.sorting);
        return [...required, ...optional, ...optionalAccessory];
    }

    /**
     * Remove optionalAccessory attributes that are not present on any variant combination.
     * Prevents rendering a step for an accessory when no variant supports it.
     */
    function filterAttributesByVariantSupport(attributes = [], variants = []) {
        if (!variants || variants.length === 0) {
            return attributes;
        }

        const filtered = [];
        attributes.forEach(attr => {
            if (attr.attributeBehaviour === 'optionalAccessory') {
                const hasVariantSupport = variants.some(v => {
                    const combo = v.attributeCombination || {};
                    return Object.prototype.hasOwnProperty.call(combo, attr.attributeLevel);
                });

                if (!hasVariantSupport) {
                    console.log(`Removing optional accessory "${attr.attributeLevel}" - no variants contain this attribute`);
                    return; // skip adding this attribute
                }
            }

            filtered.push(attr);
        });

        return filtered;
    }

    /**
     * Hide optional accessory steps until all 6 required steps are completed.
     * Only show optional accessories AFTER completing step 6 if matching variants have them.
     */
    function hideOptionalAccessoryStepsIfNoVariants(currentSelections, availableOptions) {
        console.log('🔍 hideOptionalAccessoryStepsIfNoVariants called');
        
        if (!window.apiProductData || !window.apiProductData.product) {
            console.log('No API product data available for optional accessory check');
            return;
        }

        const product = window.apiProductData.product;
        // Combine required and optional variants
        const requiredVariants = product.required?.variants || [];
        const optionalVariants = product.optional?.variants || [];
        const allVariants = [...requiredVariants, ...optionalVariants];

        console.log(`Total variants: ${allVariants.length} (${requiredVariants.length} required, ${optionalVariants.length} optional)`);

        // Get required/optional steps (excluding optional accessories)
        const requiredAndOptionalSteps = sortedAttributes.filter(
            attr => attr.attributeBehaviour !== 'optionalAccessory'
        );

        console.log(`Total required steps to check: ${requiredAndOptionalSteps.length}`);

        // Count how many required steps are completed
        let completedRequiredSteps = 0;
        requiredAndOptionalSteps.forEach((attribute, index) => {
            const stepIndex = sortedAttributes.findIndex(a => a.attributeLevel === attribute.attributeLevel);
            const completed = isStepCompleted(stepIndex);
            console.log(`  Step ${stepIndex} (${attribute.attributeLevel}): ${completed ? '✅ completed' : '❌ not completed'}`);
            if (completed) {
                completedRequiredSteps++;
            }
        });

        const allRequiredStepsCompleted = completedRequiredSteps === requiredAndOptionalSteps.length;

        console.log(`Completed ${completedRequiredSteps} of ${requiredAndOptionalSteps.length} required steps. All completed: ${allRequiredStepsCompleted}`);

        // Always hide optional accessories until all required steps are completed
        if (!allRequiredStepsCompleted) {
            sortedAttributes.forEach((attribute, stepIndex) => {
                if (attribute.attributeBehaviour === 'optionalAccessory') {
                    const $stepElement = $(`.form-step[data-step="${stepIndex}"]`);
                    $stepElement.hide();
                    console.log(`Hiding optional accessory step "${attribute.attributeLevel}" - required steps not all completed`);
                }
            });
            // Hide optional section header when required steps are not all completed
            $('.optional-section').hide();
            return;
        }

        // All required steps are completed - now check if we should show optional accessories

        // Group selections by attribute name (excluding optional accessories)
        const selectionsByAttribute = {};
        currentSelections.forEach(selection => {
            // Find if this attribute is an optional accessory
            const attr = sortedAttributes.find(a => a.attributeLevel === selection.attributeName);
            if (attr && attr.attributeBehaviour === 'optionalAccessory') {
                return; // Skip optional accessory selections when filtering
            }
            
            if (!selectionsByAttribute[selection.attributeName]) {
                selectionsByAttribute[selection.attributeName] = [];
            }
            selectionsByAttribute[selection.attributeName].push(selection.value);
        });

        console.log('Selections by attribute (excluding optional accessories):', selectionsByAttribute);

        // Filter variants that match current required/optional selections
        const matchingVariants = allVariants.filter(variant => {
            const combination = variant.attributeCombination || {};
            
            // Check if variant matches all current required/optional selections
            for (const [attributeName, selectedValues] of Object.entries(selectionsByAttribute)) {
                const variantValue = combination[attributeName];
                // Handle array values in variant (for multi-select)
                if (Array.isArray(variantValue)) {
                    const hasMatch = variantValue.some(v => selectedValues.includes(v));
                    if (!hasMatch) {
                        return false;
                    }
                } else if (!variantValue || !selectedValues.includes(variantValue)) {
                    return false;
                }
            }
            
            return true;
        });

        console.log(`Found ${matchingVariants.length} variants matching required/optional selections:`, matchingVariants);

        // Check each optional accessory step
        console.log(`\n🔎 Checking optional accessory steps...`);
        console.log(`Total sortedAttributes: ${sortedAttributes.length}`);
        console.log(`Attributes list:`, sortedAttributes.map((a, i) => `${i}: ${a.attributeLevel} (${a.attributeBehaviour})`));
        
        // Get optional steps from API response
        const optionalSteps = product.optional?.steps || [];
        console.log(`Optional steps from API: ${optionalSteps.length}`);
        if (optionalSteps.length > 0) {
            console.log(`Optional step names from API:`, optionalSteps.map(s => s.attribute?.name || s.attribute?.displayName));
        }
        
        sortedAttributes.forEach((attribute, stepIndex) => {
            if (attribute.attributeBehaviour === 'optionalAccessory') {
                const attributeName = attribute.attributeLevel;
                const stepElement = $(`.form-step[data-step="${stepIndex}"]`);

                console.log(`\n📋 Checking optional accessory step: "${attributeName}"`);
                
                // SIMPLE LOGIC: If this optional step exists in product.optional.steps from API, show it
                // Optional steps are INDEPENDENT from required selections
                const optionalStepExists = optionalSteps.some(step => {
                    const stepAttrName = step.attribute?.name || step.attribute?.displayName;
                    const matches = stepAttrName === attributeName || 
                                   stepAttrName?.includes(attributeName) || 
                                   attributeName.includes(stepAttrName);
                    
                    if (matches) {
                        console.log(`  ✅ Found matching optional step in API:`, stepAttrName);
                    }
                    return matches;
                });
                
                if (optionalStepExists) {
                    console.log(`✅ Optional accessory step "${attributeName}" EXISTS in API product.optional.steps`);
                    console.log(`   This step is INDEPENDENT from required selections - it will always be available`);
                    // Mark as available - it will be shown when user navigates to it
                    stepElement.attr('data-available', 'true');
                    // Don't force hide it here - let showStep() control visibility
                    console.log(`   ✅ Step marked as available`);
                } else {
                    console.log(`❌ Optional accessory step "${attributeName}" NOT FOUND in API product.optional.steps`);
                    stepElement.attr('data-available', 'false');
                    stepElement.hide();
                    
                    // Clear any selection for this hidden step
                    stepElement.find('select').val('');
                    stepElement.find('input[type="radio"], input[type="checkbox"]').prop('checked', false);
                }
            }
        });

        // Update navigation buttons and progress after hiding/showing steps
        updateNavigationButtons();
        updateProgressBar();
        updateProgressStats();
    }

    // Function to check which options are available for remaining steps using existing product data
    function checkAvailableOptions(currentSelections) {
        // Use the product data that's already loaded
        if (!window.apiProductData || !window.apiProductData.product) {
            console.warn('Product data not available for availability check - allowing all options');
            // Return empty object to allow all options when API data is not available
            return {};
        }

        const product = window.apiProductData.product;
        // Combine required and optional variants
        const requiredVariants = product.required?.variants || [];
        const optionalVariants = product.optional?.variants || [];
        const allVariants = [...requiredVariants, ...optionalVariants];
        
        // Even with no selections, we want to show only available options for the first step
        // So we'll continue to check availability based on all variants

        // Group selections by attribute name to handle checkboxes (multiple values per attribute)
        const selectionsByAttribute = {};
        if (currentSelections && currentSelections.length > 0) {
            currentSelections.forEach(selection => {
                if (!selectionsByAttribute[selection.attributeName]) {
                    selectionsByAttribute[selection.attributeName] = [];
                }
                selectionsByAttribute[selection.attributeName].push(selection.value);
            });
        }

        // Filter variants that match current selections
        const matchingVariants = allVariants.filter(variant => {
            const combination = variant.attributeCombination || {};
            
            // Check if variant matches all current selections
            for (const [attributeName, selectedValues] of Object.entries(selectionsByAttribute)) {
                const variantValue = combination[attributeName];
                if (!variantValue || !selectedValues.includes(variantValue)) {
                    return false; // This variant doesn't match
                }
            }
            
            return true; // Variant matches all selections
        });

        // Get all attribute names from required and optional steps
        const requiredSteps = product.required?.steps || [];
        const optionalSteps = product.optional?.steps || [];
        const allAttributeNames = [
            ...requiredSteps.map(step => step.attribute.name),
            ...optionalSteps.map(step => step.attribute.name)
        ];
        
        // Get attribute names that are already selected
        const selectedAttributeNames = Object.keys(selectionsByAttribute);
        
        // Get remaining attribute names (not yet selected)
        const remainingAttributeNames = allAttributeNames.filter(
            name => !selectedAttributeNames.includes(name)
        );

        // For each attribute (both selected and remaining), find which values exist in matching variants
        // This allows us to validate already-selected steps when previous steps change
        const availableOptions = {};

        // Check availability for ALL attributes (not just remaining ones)
        // This way we can validate already-selected steps when previous selections change
        for (const attributeName of allAttributeNames) {
            const attr = sortedAttributes.find(a => a.attributeLevel === attributeName);
            const isOptionalAccessory = attr && attr.attributeBehaviour === 'optionalAccessory';
            
            // Find the index of this attribute in sortedAttributes to determine order
            const currentAttributeIndex = sortedAttributes.findIndex(a => a.attributeLevel === attributeName);
            
            // When checking availability for an attribute, only match based on steps that come BEFORE it
            // For optional accessories, only consider required selections (not other optional selections)
            // This ensures that when a previous step changes, we can properly show options for later steps
            const selectionsFromPreviousSteps = {};
            for (const [key, value] of Object.entries(selectionsByAttribute)) {
                // Find the index of this selection's attribute
                const selectionAttrIndex = sortedAttributes.findIndex(a => a.attributeLevel === key);
                const selectionAttr = sortedAttributes.find(a => a.attributeLevel === key);
                
                // For optional accessories, only consider required selections
                if (isOptionalAccessory && selectionAttr && selectionAttr.attributeBehaviour === 'optionalAccessory') {
                    continue; // Skip other optional accessory selections when checking optional accessory availability
                }
                
                // Only include selections from steps that come BEFORE the current attribute
                // This way, if step 3 changes, step 4 availability is based only on steps 1, 2, 3
                if (selectionAttrIndex >= 0 && selectionAttrIndex < currentAttributeIndex) {
                    selectionsFromPreviousSteps[key] = value;
                }
            }
            
            // Filter variants that match selections from PREVIOUS steps only
            // For optional accessories, only check optional variants (they're independent from required variants)
            const variantsToCheck = isOptionalAccessory ? optionalVariants : allVariants;
            
            let variantsForThisAttribute;
            if (isOptionalAccessory) {
                // For optional accessories, DON'T filter based on required selections
                // Optional variants are independent and don't have required attributes in their combination
                // Just use ALL optional variants to get all available values
                console.log(`  Checking optional accessory "${attributeName}" - using ALL ${variantsToCheck.length} optional variants (no filtering)`);
                variantsForThisAttribute = variantsToCheck;
            } else {
                // For required attributes, filter based on previous selections
                variantsForThisAttribute = variantsToCheck.filter(variant => {
                    const combination = variant.attributeCombination || {};
                    
                    // Check if variant matches all selections from previous steps
                    for (const [attrName, selectedValues] of Object.entries(selectionsFromPreviousSteps)) {
                        const variantValue = combination[attrName];
                        if (!variantValue || !selectedValues.includes(variantValue)) {
                            return false;
                        }
                    }
                    
                    return true;
                });
            }
            
            if (isOptionalAccessory) {
                console.log(`  Found ${variantsForThisAttribute.length} optional variants (all variants used)`);
            }
            
            const availableValues = new Set();
            
            // Check each matching variant for this attribute's value
            variantsForThisAttribute.forEach(variant => {
                const combination = variant.attributeCombination || {};
                if (combination[attributeName]) {
                    availableValues.add(combination[attributeName]);
                }
            });
            
            // Convert Set to sorted array
            availableOptions[attributeName] = Array.from(availableValues).sort();
            
            if (isOptionalAccessory) {
                console.log(`  Available values for optional accessory "${attributeName}":`, availableOptions[attributeName]);
            }
        }

        console.log('=== Availability Check ===');
        console.log('Current selections:', currentSelections);
        console.log('Matching variants count:', matchingVariants.length);
        console.log('Matching variants:', matchingVariants.map(v => ({
            id: v.id,
            combination: v.attributeCombination
        })));
        console.log('Remaining attributes:', remainingAttributeNames);
        console.log('Available options from product data:', availableOptions);
        return availableOptions;
    }

    // Function to update option availability (disable/gray out unavailable options)
    function updateOptionAvailability() {
        // Prevent recursive calls
        if (isUpdatingAvailability) {
            console.log('Already updating availability, skipping recursive call');
            return;
        }
        
        isUpdatingAvailability = true;
        
        try {
            // If API data is not available, don't restrict options - allow all
            if (!window.apiProductData || !window.apiProductData.product) {
                console.log('API data not available - allowing all options');
                return;
            }
            
            const currentFormData = collectFormData();
            console.log('updateOptionAvailability - Current form data:', currentFormData);
        
        // Convert form data to selection format
        let currentSelections = [];
        for (const [attributeName, value] of Object.entries(currentFormData)) {
            if (value && value !== '' && value !== null) {
                if (Array.isArray(value)) {
                    // For checkboxes, add each selected value
                    value.forEach(v => {
                        if (v) currentSelections.push({ attributeName, value: v });
                    });
                } else {
                    currentSelections.push({ attributeName, value });
                }
            }
        }

        console.log('updateOptionAvailability - Current selections array:', currentSelections);

        // Check available options using existing product data (no API call needed)
        let availableOptions = checkAvailableOptions(currentSelections);
        console.log('updateOptionAvailability - Available options result:', availableOptions);

        // Hide optional accessory steps if no variants with current selections have that accessory
        hideOptionalAccessoryStepsIfNoVariants(currentSelections, availableOptions);

        // Track which steps need to be cleared (so we can clear subsequent steps too)
        const stepsToClear = [];
        
        // First pass: identify which steps need to be cleared
        sortedAttributes.forEach((attribute, stepIndex) => {
            const attributeName = attribute.attributeLevel;
            const isOptionalAccessory = attribute.attributeBehaviour === 'optionalAccessory';
            
            // Check if this attribute is already selected
            const isSelected = currentSelections.some(s => s.attributeName === attributeName);
            const currentValue = isSelected ? currentSelections.find(s => s.attributeName === attributeName)?.value : null;

            // Get available values for this attribute
            const availableValues = availableOptions[attributeName] || [];

            // If this step has a value but it's no longer available, mark it for clearing
            // For optional accessories, clear if no variants match required selections
            if (isSelected && currentValue) {
                // Clear if: value is not in available list, OR no variants match at all
                if (availableValues.length === 0 || !availableValues.includes(currentValue)) {
                    console.log(`⚠️ Marking "${attributeName}" (step ${stepIndex})${isOptionalAccessory ? ' (optional accessory)' : ''} for clearing - value "${currentValue}" no longer available`);
                    stepsToClear.push(stepIndex);
                }
            }
        });
        
        // Clear all marked steps AND all subsequent steps
        const clearedSteps = new Set();
        stepsToClear.forEach(stepIndexToClear => {
            // Clear this step and all steps after it (including optional accessories)
            for (let i = stepIndexToClear; i < sortedAttributes.length; i++) {
                if (clearedSteps.has(i)) {
                    continue; // Already cleared
                }
                
                const attr = sortedAttributes[i];
                const stepElement = $(`.form-step[data-step="${i}"]`);
                const select = stepElement.find('select');
                if (select.length > 0 && select.val() !== '') {
                    console.log(`Clearing step ${i}: ${attr.attributeLevel}${attr.attributeBehaviour === 'optionalAccessory' ? ' (optional accessory)' : ''}`);
                    select.val('').trigger('change'); // Clear and trigger change (flag prevents recursion)
                    clearedSteps.add(i);
                }
                
                const inputs = stepElement.find('input[type="radio"]:checked, input[type="checkbox"]:checked');
                if (inputs.length > 0) {
                    inputs.each(function() {
                        $(this).prop('checked', false).trigger('change'); // Clear and trigger change (flag prevents recursion)
                    });
                    clearedSteps.add(i);
                }
            }
        });
        
        // If we cleared any steps, we need to recalculate with fresh form data
        if (clearedSteps.size > 0) {
            console.log(`Cleared ${clearedSteps.size} steps, recalculating with fresh data...`);
            // Get fresh form data after clearing
            const freshFormData = collectFormData();
            const freshSelections = [];
            for (const [attributeName, value] of Object.entries(freshFormData)) {
                if (value && value !== '' && value !== null) {
                    if (Array.isArray(value)) {
                        value.forEach(v => {
                            if (v) freshSelections.push({ attributeName, value: v });
                        });
                    } else {
                        freshSelections.push({ attributeName, value });
                    }
                }
            }
            
            // Recalculate availability with fresh selections
            const freshAvailableOptions = checkAvailableOptions(freshSelections);
            
            // Update currentSelections and availableOptions for the rest of the function
            currentSelections = freshSelections;
            availableOptions = freshAvailableOptions;
        }
        
        // Second pass: update availability for all steps (including optional accessories)
        sortedAttributes.forEach((attribute, stepIndex) => {
            const attributeName = attribute.attributeLevel;
            const isOptionalAccessory = attribute.attributeBehaviour === 'optionalAccessory';
            const stepElement = $(`.form-step[data-step="${stepIndex}"]`);
            
            // Check if this attribute is already selected (after clearing)
            const isSelected = currentSelections.some(s => s.attributeName === attributeName);
            const currentValue = isSelected ? currentSelections.find(s => s.attributeName === attributeName)?.value : null;

            // Get available values for this attribute
            let availableValues = availableOptions[attributeName] || [];
            
            // For optional accessories with no selections, get values directly from variants
            if (isOptionalAccessory && availableValues.length === 0 && currentSelections.length === 0) {
                const directValues = getAvailableValuesFromVariants(attributeName, true);
                if (directValues !== null) {
                    availableValues = directValues;
                    console.log(`  🔄 Using direct variant check for optional accessory "${attributeName}":`, availableValues);
                }
            }
            
            console.log(`Checking availability for "${attributeName}":`, {
                isOptionalAccessory,
                availableValues,
                availableValuesCount: availableValues.length,
                hasOptions: availableValues.length > 0,
                currentSelectionsCount: currentSelections.length,
                isSelected: isSelected,
                currentValue: currentValue
            });
            
            // Check if we have current selections
            const hasCurrentSelections = currentSelections.length > 0;
            
            // Check if there are any matching variants at all
            // If availableOptions has keys but all values are empty arrays, no variants match
            const hasAnyMatchingVariants = Object.keys(availableOptions).length > 0 && 
                Object.values(availableOptions).some(values => values.length > 0);
            
            // If we have selections but no matching variants exist, disable all options
            const shouldDisableAll = hasCurrentSelections && !hasAnyMatchingVariants && Object.keys(availableOptions).length > 0;
            
            // Update dropdown options
            const select = stepElement.find('select');
            if (select.length > 0) {
                
                select.find('option').each(function() {
                    const $option = $(this);
                    const optionValue = $option.val();
                    
                    if (optionValue === '') {
                        // Keep default option enabled (unless no matches at all)
                        $option.prop('disabled', shouldDisableAll).toggleClass('unavailable', shouldDisableAll);
                    } else if (shouldDisableAll) {
                        // Disable all options if no variants match current selections
                        $option.prop('disabled', true).addClass('unavailable');
                    } else if (hasCurrentSelections) {
                        // If we have selections, check if this option is available
                        if (availableValues.length === 0) {
                            // No variants match previous steps - enable all options so user can try different combinations
                            $option.prop('disabled', false).removeClass('unavailable');
                        } else if (!availableValues.includes(optionValue)) {
                            // Option not in available list - disable it
                            $option.prop('disabled', true).addClass('unavailable');
                        } else {
                            // Option is available - enable it
                            $option.prop('disabled', false).removeClass('unavailable');
                        }
                    } else {
                        // No selections yet - show only available options (for first step)
                        // For optional accessories, use the initial available values from variants
                        let valuesToCheck = availableValues;
                        if (isOptionalAccessory && availableValues.length === 0) {
                            // Re-check variants directly for optional accessories
                            const directAvailableValues = getAvailableValuesFromVariants(attributeName, true);
                            if (directAvailableValues !== null) {
                                valuesToCheck = directAvailableValues;
                                console.log(`  🔄 Re-checking optional variants for "${attributeName}":`, valuesToCheck);
                            }
                        }
                        
                        if (valuesToCheck.length === 0) {
                            // No variants exist at all - disable all options
                            $option.prop('disabled', true).addClass('unavailable');
                            console.log(`  ❌ Disabling "${optionValue}" - no variants exist`);
                        } else if (!valuesToCheck.includes(optionValue)) {
                            // Option not in available list - disable it
                            $option.prop('disabled', true).addClass('unavailable');
                            console.log(`  ❌ Disabling "${optionValue}" - not in available values:`, valuesToCheck);
                        } else {
                            // Option is available - enable it
                            $option.prop('disabled', false).removeClass('unavailable');
                            console.log(`  ✅ Enabling "${optionValue}" - found in available values`);
                        }
                    }
                });
            }

            // Update radio/checkbox options
            const inputs = stepElement.find('input[type="radio"], input[type="checkbox"]');
            inputs.each(function() {
                const $input = $(this);
                const inputValue = $input.val();
                const $label = $input.closest('label');
                
                // Skip "No" option for toggles (always available)
                if (inputValue === 'no') {
                    $input.prop('disabled', false).removeClass('unavailable');
                    $label.removeClass('unavailable');
                    return;
                }
                
                // Clear checked state if value is no longer available
                if (shouldClearValue && $input.is(':checked') && inputValue === currentValue) {
                    $input.prop('checked', false).trigger('change');
                }
                
                if (shouldDisableAll) {
                    // Disable all options if no variants match current selections
                    $input.prop('disabled', true).addClass('unavailable');
                    $label.addClass('unavailable');
                } else if (hasCurrentSelections) {
                    // If we have selections, check if this option is available
                    if (availableValues.length === 0) {
                        // No variants match previous steps - enable all options so user can try different combinations
                        $input.prop('disabled', false).removeClass('unavailable');
                        $label.removeClass('unavailable');
                    } else if (!availableValues.includes(inputValue)) {
                        // Option not in available list - disable it
                        $input.prop('disabled', true).addClass('unavailable');
                        $label.addClass('unavailable');
                    } else {
                        // Option is available - enable it
                        $input.prop('disabled', false).removeClass('unavailable');
                        $label.removeClass('unavailable');
                    }
                } else {
                    // No selections yet - show only available options (for first step)
                    if (availableValues.length === 0) {
                        // No variants exist at all - disable all options
                        $input.prop('disabled', true).addClass('unavailable');
                        $label.addClass('unavailable');
                    } else if (!availableValues.includes(inputValue)) {
                        // Option not in available list - disable it
                        $input.prop('disabled', true).addClass('unavailable');
                        $label.addClass('unavailable');
                    } else {
                        // Option is available - enable it
                        $input.prop('disabled', false).removeClass('unavailable');
                        $label.removeClass('unavailable');
                    }
                }
            });
        });
        } finally {
            isUpdatingAvailability = false;
        }
    }

    // Get product ID from various sources
    function getProductId() {
        // Method 1: Try to get from product-info element data attribute
        const productInfoElement = document.querySelector('[data-product-id]');
        if (productInfoElement) {
            return productInfoElement.dataset.productId;
        }
        
        // Method 2: Try to get from URL if we're on a product page
        const urlPath = window.location.pathname;
        if (urlPath.includes('/products/')) {
            // Extract product handle from URL and try to find the product ID
            const productHandle = urlPath.split('/products/')[1]?.split('?')[0]?.split('#')[0];
            if (productHandle) {
                // Look for product data in the page
                const productElement = document.querySelector(`[data-product-handle="${productHandle}"]`);
                if (productElement && productElement.dataset.productId) {
                    return productElement.dataset.productId;
                }
            }
        }
        
        // Method 3: Try to get from any product form
        const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
        if (productForm) {
            const variantIdInput = productForm.querySelector('.product-variant-id');
            if (variantIdInput && variantIdInput.value) {
                // This is a variant ID, but we can use it to get product info
                return variantIdInput.value;
            }
        }
        
        // Method 4: Try to get from window.product object if available
        if (window.product && window.product.id) {
            return window.product.id;
        }
        
        // Method 5: Try to get from meta tags
        const productIdMeta = document.querySelector('meta[property="product:price:amount"]');
        if (productIdMeta) {
            // Extract product ID from meta content or other meta tags
            const productUrl = window.location.href;
            // You might need to make an API call to get the product ID from the URL
            return null; // Will need to be handled differently
        }
        
        console.warn('Product ID not found. Please ensure this script is running on a product page.');
        return null;
    }

    // Fetch attribute data from API with retry mechanism
    async function fetchAttributeData(retryCount = 0) {
        if (window.__attributePrefetch) {
            console.log('Using pre-fetched API data (skipping duplicate call)');
            var prefetched = window.__attributePrefetch;
            delete window.__attributePrefetch;
            window.apiProductData = prefetched;
            return prefetched;
        }

        if (!productId) {
            console.error('No product ID available for API call');
            return null;
        }

        const maxRetries = 2;
        
        // Cancel any previous request if starting a new one (retryCount === 0 means new request)
        if (retryCount === 0 && currentAbortController) {
            console.log('Cancelling previous API request');
            currentAbortController.abort();
            currentAbortController = null;
        }
        
        // Prevent concurrent requests (unless this is a retry)
        if (retryCount === 0 && isLoading) {
            console.warn('API request already in progress, skipping duplicate call');
            return null;
        }
        
        let controller = null; // Declare here so it's in scope in catch block
        try {
            isLoading = true;
            // Loading state is already shown by initAttributeForm, but ensure it's visible
            if (retryCount === 0) {
                showLoadingState();
            }
            
            console.log(`Fetching attribute data from: ${apiProdUrl} (attempt ${retryCount + 1})`);
            
            // Create AbortController for timeout - very short timeout for faster failure detection
            // CORS errors typically fail immediately, so we don't need to wait long
            controller = new AbortController();
            // Store controller globally so we can cancel it if a new request starts
            if (retryCount === 0) {
                currentAbortController = controller;
            }
            const timeoutDuration = retryCount === 0 ? 2000 : 3000; // 2 seconds for first attempt, 3 for retries
            const timeoutId = setTimeout(() => controller.abort(), timeoutDuration);
            
            let response;
            try {
                response = await fetch(apiProdUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Cache-Control': 'no-cache'
                    },
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
            } catch (fetchError) {
                clearTimeout(timeoutId);
                // If request was aborted (timeout or manual cancellation), check if it was intentional
                if (fetchError.name === 'AbortError') {
                    // If this was cancelled due to a new request starting, don't retry
                    if (currentAbortController !== controller) {
                        console.log('Request was cancelled by a new request, not retrying');
                        throw fetchError;
                    }
                    // Otherwise it was a timeout - allow retry
                    console.warn('Request timed out, will retry if attempts remain');
                }
                // If it's a network/CORS error, throw immediately without waiting
                if (fetchError.name === 'TypeError' || 
                    fetchError.message.includes('Failed to fetch') ||
                    fetchError.message.includes('CORS')) {
                    throw fetchError;
                }
                throw fetchError;
            }

            // Handle 404 specifically - product not found, but allow product to work normally
            if (response.status === 404) {
                console.warn('Product not found in API (404). Product will display normally without attribute form.');
                return null; // Return null gracefully - don't throw error
            }
            
            if (!response.ok) {
                console.warn(`API returned status ${response.status}. Product will display normally without attribute form.`);
                return null; // Return null for other errors too - allow product to work
            }

            const data = await response.json();
            console.log('API Response:', data);
            
            // Check if API returned error object (like {error: "Product not found"})
            if (data && data.error) {
                console.warn(`API returned error: ${data.error}. Product will display normally without attribute form.`);
                return null; // Return null gracefully
            }
            
            // Check if the API returned valid data (new structured format)
            if (data && data.success && data.product && data.product.required) {
                console.log('Successfully fetched product data from API');
                // Store the API data globally for variant matching
                window.apiProductData = data;
                return data;
            } else {
                console.warn('API response missing required structure. Product will display normally without attribute form.');
                return null;
            }
            
        } catch (error) {
            // If request was cancelled by a new request starting, don't log as error or retry
            // Check if current controller is different (meaning a new request started) - only if controller was set
            const wasCancelledByNewRequest = controller != null && error.name === 'AbortError' && retryCount === 0;
            if (wasCancelledByNewRequest) {
                // Small delay to allow currentAbortController to be updated if a new request started
                await new Promise(resolve => setTimeout(resolve, 10));
                if (currentAbortController !== controller) {
                    console.log('Request cancelled by new request, exiting gracefully');
                    return null;
                }
                // Otherwise it was a timeout - allow retry below
                console.warn('Request timed out, will retry if attempts remain');
            }
            
            // Only log error if it wasn't a cancellation by new request
            if (!(controller != null && error.name === 'AbortError' && retryCount === 0 && currentAbortController !== controller)) {
                console.error(`Error fetching attribute data (attempt ${retryCount + 1}):`, error);
            }
            
            // Check if it's a CORS or network error (but not a cancellation by new request)
            const isNetworkError = error.name === 'TypeError' || 
                                  error.message.includes('Failed to fetch') ||
                                  error.message.includes('CORS');
            
            // For network/CORS errors, return null immediately - no retries
            // Don't hide container here - let initAttributeForm handle it after processing
            if (isNetworkError) {
                console.warn('Network/CORS error detected. Continuing without API data. Variants will still display.');
                return null;
            }
            
            // Retry logic (only for non-network errors and non-cancelled requests)
            if (retryCount < maxRetries && !(controller != null && error.name === 'AbortError' && currentAbortController !== controller)) {
                console.log(`Retrying... (${retryCount + 1}/${maxRetries})`);
                await new Promise(resolve => setTimeout(resolve, 500 * (retryCount + 1))); // Shorter backoff
                return fetchAttributeData(retryCount + 1);
            }
            
            // If cancelled by new request, don't log failure
            if (controller != null && error.name === 'AbortError' && currentAbortController !== controller) {
                return null;
            }
            
            console.log('All retry attempts failed, continuing without API data');
            // Return null - let initAttributeForm handle hiding
            return null;
        } finally {
            isLoading = false;
            // Clear abort controller if this was the last attempt (not a retry)
            if (retryCount === 0) {
                currentAbortController = null;
            }
            // Don't hide anything here - let initAttributeForm decide based on the result
        }
    }

    // Show loading state
    function showLoadingState() {
        const formContainer = $('#attribute-form-container');
        if (formContainer.length) {
            formContainer.html(`
                <div class="loading-state" style="text-align: center; padding: 40px;">
                    <div class="loading-spinner" style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
                    <p>Loading product configuration...</p>
                    <style>
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    </style>
                </div>
            `);
        }
    }

    // Hide loading state
    function hideLoadingState(hideContainer = false) {
        // Hide container first (synchronously) if requested
        if (hideContainer) {
            $('.pdp_attribute__container').hide();
        }
        // Then remove loading state
        const loadingState = $('.loading-state');
        if (loadingState.length) {
            loadingState.remove();
        }
        // Also hide container if no data available
        if (!hideContainer && (!attributeData || !attributeData.attributeData)) {
            $('.pdp_attribute__container').hide();
        }
    }

    // Validate and transform API data
    function validateApiData(data) {
        if (!data || typeof data !== 'object') {
            console.warn('Invalid API data: not an object');
            return null;
        }

        if (!data.attributeData || !Array.isArray(data.attributeData)) {
            console.warn('Invalid API data: missing or invalid attributeData array');
            return null;
        }

        // Validate each attribute
        const validAttributes = data.attributeData.filter(attr => {
            if (!attr.attributeLevel || !attr.attributeType) {
                console.warn('Invalid attribute: missing required fields', attr);
                return false;
            }
            
            if (!attr.options || !Array.isArray(attr.options)) {
                console.warn('Invalid attribute: missing or invalid options array', attr);
                return false;
            }
            
            return true;
        });

        if (validAttributes.length === 0) {
            console.warn('No valid attributes found in API data');
            return null;
        }

        console.log(`Validated ${validAttributes.length} attributes from API`);
        return {
            attributeData: validAttributes
        };
    }

    // Handle API data processing
    function processApiData(apiData) {
        if (!apiData) {
            console.log('No API data to process');
            return null;
        }

        // Transform the API response to our expected format
        const transformedData = transformApiResponse(apiData);
        if (transformedData) {
            return transformedData;
        }

        console.log('API data transformation failed');
        return null;
    }

    // Refresh form data from API
    async function refreshFormData() {
        console.log('Refreshing form data from API...');
        
        try {
            const rawApiData = await fetchAttributeData();
            const newAttributeData = processApiData(rawApiData);
            
            if (newAttributeData && newAttributeData.attributeData) {
                const product = (window.apiProductData && window.apiProductData.product) || {};
                const requiredVariants = product.required?.variants || [];
                const optionalVariants = product.optional?.variants || [];
                const variants = [...requiredVariants, ...optionalVariants];
                const filteredAttributes = filterAttributesByVariantSupport(newAttributeData.attributeData, variants);
                attributeData = { attributeData: filteredAttributes };
                sortedAttributes = sortAttributesWithOptionalLast(attributeData.attributeData);
                
                // Recreate the form with new data
                createFormSteps();
                showStep(0);
                updateProgressBar();
                updateProgressStats();
                
                console.log('Form data refreshed successfully');
                return true;
            } else {
                throw new Error('Failed to process refreshed data');
            }
        } catch (error) {
            console.error('Failed to refresh form data:', error);
            return false;
        }
    }

    // Make refresh function globally available
    window.refreshAttributeForm = refreshFormData;

    // Get the complete API URL with product ID
    function getApiUrl() {
        if (productId) {
            return apiProdUrl;
        }
        return null;
    }

    // Initialize the form
    async function initAttributeForm() {
        // Prevent multiple concurrent initializations
        if (isInitializing) {
            console.warn('Attribute form initialization already in progress, skipping duplicate call');
            return;
        }
        
        // Check if the container exists
        const formContainer = $('#attribute-form-container');
        if (!formContainer.length) {
            console.error('Attribute form container not found. Cannot initialize attribute form.');
            return;
        }
        
        // Check if we have a valid product ID before proceeding
        if (!productId) {
            console.error('Product ID not available. Cannot initialize attribute form.');
            // Hide both the form container and parent container
            formContainer.hide();
            $('.pdp_attribute__container').hide();
            return;
        }
        
        isInitializing = true;
        
        console.log('Product ID found:', productId);
        console.log('API URL:', getApiUrl());
        
        // Show the container and loading state immediately
        // But don't force show if it's already hidden (for products without attribute form)
        if ($('.pdp_attribute__container').length > 0) {
            $('.pdp_attribute__container').show();
        }
        showLoadingState();
        
        try {
            // Fetch attribute data from API (non-blocking)
            const rawApiData = await fetchAttributeData();
            
            // Process and validate the API data
            attributeData = processApiData(rawApiData);
            
            if (attributeData && attributeData.attributeData) {
                const product = (window.apiProductData && window.apiProductData.product) || {};
                const requiredVariants = product.required?.variants || [];
                const optionalVariants = product.optional?.variants || [];
                const variants = [...requiredVariants, ...optionalVariants];
                const filteredAttributes = filterAttributesByVariantSupport(attributeData.attributeData, variants);
                attributeData = { attributeData: filteredAttributes };
                
                // Sort attributes by required first, then optional (keeps original order within each group)
                sortedAttributes = sortAttributesWithOptionalLast(attributeData.attributeData);
                console.log('Sorted attributes:', sortedAttributes);
                
                // Remove loading state and show the form
                $('.loading-state').remove();
                
                // Container is already shown, just create and display the form
                createFormSteps();
                
                // Check option availability FIRST (including marking optional steps as available)
                updateOptionAvailability();
                
                // Find first incomplete step or show step 0
                let startStep = 0;
                for (let i = 0; i < sortedAttributes.length; i++) {
                    if (!isStepCompleted(i)) {
                        startStep = i;
                        console.log(`Starting at first incomplete step: ${i} (${sortedAttributes[i]?.attributeLevel})`);
                        break;
                    }
                }
                
                showStep(startStep);
                updateProgressBar();
                updateProgressStats();
            } else {
                // API failed or returned 404/no data - hide attribute form, show default product form (Select Model, Add to Cart)
                console.warn('No attribute data from API (e.g. 404). Showing default product form (variant selector + Add to Cart).');
                $('.loading-state').remove();
                $('.pdp_attribute__container').hide();
                // attribute-form.css hides .product__config-option until .variants-visible is set - add it so "Select Model" shows
                $('.product__config-option').addClass('variants-visible');
                $('.product__config-option-values-list').addClass('variants-visible');
            }
        } catch (error) {
            console.error('Error initializing attribute form:', error);
            $('.loading-state').remove();
            $('.pdp_attribute__container').hide();
            // Show default product form (Select Model, variant options, Add to Cart)
            $('.product__config-option').addClass('variants-visible');
            $('.product__config-option-values-list').addClass('variants-visible');
            console.log('Attribute form failed. Showing default product form (variant selector + Add to Cart).');
        } finally {
            isInitializing = false;
        }
    }

    // Get available values for an attribute from variants (for initial filtering)
    function getAvailableValuesFromVariants(attributeName, isOptionalAccessory) {
        console.log(`\n🔍 getAvailableValuesFromVariants called:`, {
            attributeName,
            isOptionalAccessory,
            hasApiData: !!(window.apiProductData && window.apiProductData.product)
        });
        
        if (!window.apiProductData || !window.apiProductData.product) {
            console.log(`  ❌ No API data available - returning null`);
            return null; // Can't filter without variant data
        }
        
        const product = window.apiProductData.product;
        const optionalVariants = product.optional?.variants || [];
        const requiredVariants = product.required?.variants || [];
        
        // For optional accessories, only check optional variants (they use different variants than required)
        // For required attributes, only check required variants
        const variantsToCheck = isOptionalAccessory ? optionalVariants : requiredVariants;
        
        console.log(`  📊 Variant data:`, {
            optionalVariantsCount: optionalVariants.length,
            requiredVariantsCount: requiredVariants.length,
            variantsToCheckCount: variantsToCheck.length,
            variantType: isOptionalAccessory ? 'optional' : 'required'
        });
        
        if (variantsToCheck.length > 0) {
            console.log(`  📦 Variants to check:`, variantsToCheck.map(v => ({
                id: v.id,
                combination: v.attributeCombination
            })));
        }
        
        const availableValues = new Set();
        variantsToCheck.forEach(variant => {
            const combination = variant.attributeCombination || {};
            console.log(`  🔎 Checking variant ${variant.id}:`, {
                combination,
                hasAttribute: !!combination[attributeName],
                attributeValue: combination[attributeName]
            });
            if (combination[attributeName]) {
                availableValues.add(combination[attributeName]);
                console.log(`    ✅ Added value "${combination[attributeName]}" to available values`);
            } else {
                console.log(`    ⚠️ Variant ${variant.id} does not have attribute "${attributeName}"`);
            }
        });
        
        const result = Array.from(availableValues);
        console.log(`  ✨ Final available values for "${attributeName}" (${isOptionalAccessory ? 'optional' : 'required'}):`, result);
        console.log(`  📝 Available values array:`, JSON.stringify(result));
        
        // For optional accessories: if optional variants exist but this attribute has no values, 
        // still return empty array to disable "No" when no variants have this attribute
        if (isOptionalAccessory && result.length === 0 && optionalVariants.length > 0) {
            console.log(`  ⚠️ Optional variants exist but none have "${attributeName}" - returning empty (will disable "No")`);
        }
        
        return result;
    }

    // Create form steps based on JSON data
    function createFormSteps() {
        const formContainer = $('#attribute-form-container');
        formContainer.empty();

        // Create progress bar
        const progressBar = $(`
            <div class="form-progress">
                <div class="progress-bar">
                    <div class="progress-fill progress-low"></div>
                </div>
                <div class="step-indicators"></div>
                <div class="progress-stats">
                    <span class="completed-steps">0</span> of <span class="total-steps">${sortedAttributes.length}</span> <span class="progress-label">questions completed</span>
                </div>
            </div>
        `);
        formContainer.append(progressBar);
        
        // Create section headers container directly below form-progress
        const sectionHeadersContainer = $('<div class="section-headers-container"></div>');
        
        // Create "Required Attributes" section header
        const requiredSection = $('<div>')
            .addClass('form-section-header required-section')
            .html('<h2 class="section-title">Required Attributes</h2><p class="section-description">Please complete all required fields to configure your product</p>');
        sectionHeadersContainer.append(requiredSection);
        
        // Create "Optional Accessories" section header
        const optionalSection = $('<div>')
            .addClass('form-section-header optional-section')
            .html('<h2 class="section-title">Optional Accessories</h2><p class="section-description">Enhance your product with these optional add-ons</p>');
        sectionHeadersContainer.append(optionalSection);
        
        // Initially hide optional section header
        optionalSection.hide();
        
        // Append section headers container below form-progress (above current-step-title)
        formContainer.append(sectionHeadersContainer);
        
        // Create current step title (storeTitle) - displayed below section headers
        const currentStepTitle = $('<div class="current-step-title"></div>');
        formContainer.append(currentStepTitle);
        
        // Add CSS styles for form elements
        $('<style>')
            .prop('type', 'text/css')
            .html(`
                .form-header {
                    text-align: center;
                    margin-bottom: 30px;
                    padding: 20px;
                    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                    border-radius: 8px;
                    border: 1px solid #dee2e6;
                }
                
                .form-header h2 {
                    color: #2c3e50;
                    margin: 0 0 10px 0;
                    font-size: 24px;
                    font-weight: 600;
                }
                
                .form-header p {
                    color: #6c757d;
                    margin: 0;
                    font-size: 16px;
                }
                
                .form-section-header {
                    margin: 30px 0 20px 0;
                    padding: 20px;
                    border-radius: 8px;
                    border-left: 4px solid;
                    background: #f8f9fa;
                }
                
                .form-section-header.required-section {
                    border-left-color: #2196F3;
                    background: linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%);
                }
                
                .form-section-header.optional-section {
                    border-left-color: #ff9800;
                    background: linear-gradient(135deg, #fff3e0 0%, #f5f5f5 100%);
                }
                
                .form-section-header .section-title {
                    margin: 0 0 8px 0;
                    color: #2c3e50;
                    font-size: 20px;
                    font-weight: 700;
                }
                
                .form-section-header.required-section .section-title {
                    color: #1976d2;
                }
                
                .form-section-header.optional-section .section-title {
                    color: #f57c00;
                }
                
                .form-section-header .section-description {
                    margin: 0;
                    color: #6c757d;
                    font-size: 14px;
                    font-style: italic;
                }
                
                .section-headers-container {
                    width: 100%;
                    margin-top: 20px;
                    margin-bottom: 20px;
                }
                
                .section-headers-container .form-section-header {
                    margin-top: 0;
                    margin-bottom: 0;
                }
                
                .progress-fill {
                    transition: all 0.3s ease;
                    border-radius: 4px;
                }
                
                .progress-fill.progress-low {
                    background: linear-gradient(90deg, #ff4444, #ff6666);
                }
                
                .progress-fill.progress-medium {
                    background: linear-gradient(90deg, #ffaa00, #ffcc00);
                }
                
                .progress-fill.progress-high {
                    background: linear-gradient(90deg, #ff8800, #ffaa00);
                }
                
                .progress-fill.progress-complete {
                    background: linear-gradient(90deg, #4CAF50, #45a049);
                }
                
                .step-indicator {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    margin: 0 4px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border: 2px solid #e0e0e0;
                }
                
                .step-indicator.completed {
                    background-color: #4CAF50;
                    border-color: #4CAF50;
                    transform: scale(1.1);
                }
                
                .step-indicator.current {
                    background-color: #2196F3;
                    border-color: #2196F3;
                    transform: scale(1.2);
                }
                
                .step-indicator.pending {
                    background-color: #e0e0e0;
                    border-color: #e0e0e0;
                }
                
                /* All step indicators are clickable */
                .step-indicator:hover {
                    transform: scale(1.3);
                    opacity: 0.8;
                }
                
                .step-indicator.completed:hover {
                    box-shadow: 0 0 8px rgba(76, 175, 80, 0.4);
                }
                
                .step-indicator.current:hover {
                    box-shadow: 0 0 8px rgba(33, 150, 243, 0.4);
                }
                
                .step-indicator.pending:hover {
                    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
                }
                
                .progress-stats {
                    text-align: center;
                    margin-top: 15px;
                    color: #666;
                    font-size: 14px;
                }
                
                .current-step-title {
                    text-align: left;
                    margin-top: 20px;
                    margin-bottom: 15px;
                    color: #333;
                    font-size: 20px;
                    font-weight: 600;
                    padding-left: 0;
                }
                
                .completed-steps {
                    color: #4CAF50;
                    font-weight: 600;
                }
                
                .total-steps {
                    color: #333;
                    font-weight: 600;
                }
                
                .progress-updated {
                    animation: progressPulse 0.3s ease;
                }
                
                @keyframes progressPulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.02); }
                    100% { transform: scale(1); }
                }
                
                .progress-bar {
                    width: 100%;
                    height: 12px;
                    background-color: #f0f0f0;
                    border-radius: 6px;
                    overflow: hidden;
                    margin-bottom: 20px;
                    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
                }
                
                .step-header {
                    margin-bottom: 20px;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #e0e0e0;
                }
                
                .step-header h3 {
                    margin: 0 0 10px 0;
                    color: #2c3e50;
                    font-size: 18px;
                    font-weight: 600;
                }
                
                .form-control {
                    width: 100%;
                    padding: 12px;
                    border: 2px solid #e0e0e0;
                    border-radius: 6px;
                    font-size: 16px;
                    transition: border-color 0.3s ease;
                }
                
                .form-control:focus {
                    outline: none;
                    border-color: #2196F3;
                    box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
                }
                
                .toggle-group, .checkbox-group {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                
                .toggle-option, .checkbox-option {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 12px;
                    border: 2px solid #e0e0e0;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                
                .toggle-option:hover, .checkbox-option:hover {
                    border-color: #2196F3;
                    background-color: #f8f9fa;
                }
                
                .toggle-option input, .checkbox-option input {
                    margin: 0;
                    cursor: pointer;
                }
                
                .toggle-label, .checkbox-label {
                    cursor: pointer;
                    font-size: 16px;
                    color: #2c3e50;
                }
                
                .form-navigation {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 30px;
                    padding-top: 20px;
                    border-top: 1px solid #e0e0e0;
                }
                
                .btn {
                    padding: 12px 24px;
                    border: none;
                    border-radius: 6px;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                
                .btn-prev {
                    background-color: #6c757d;
                    color: white;
                }
                
                .btn-prev:hover {
                    background-color: #5a6268;
                }
                
                .btn-next, .btn-submit {
                    background-color: #2196F3;
                    color: white;
                }
                
                .btn-next:hover, .btn-submit:hover {
                    background-color: #1976d2;
                }
                
                .btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
                
                .validation-message {
                    color: #d32f2f;
                    font-size: 14px;
                    margin-top: 8px;
                    display: none;
                    padding: 8px 12px;
                    background-color: #ffebee;
                    border-left: 3px solid #d32f2f;
                    border-radius: 4px;
                }
                
                .validation-message.show {
                    display: block;
                }
                
                .variants-list {
                    margin: 20px 0;
                }
                
                .variant-option {
                    display: flex;
                    align-items: flex-start;
                    gap: 20px;
                    padding: 20px;
                    border: 2px solid #e0e0e0;
                    border-radius: 8px;
                    margin-bottom: 20px;
                    transition: all 0.3s ease;
                    position: relative;
                }
                
                .variant-option.selected {
                    border-color: #2196F3;
                    background-color: #f8f9fa;
                    box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
                }
                
                .variant-option:hover {
                    border-color: #1976d2;
                    box-shadow: 0 4px 12px rgba(33, 150, 243, 0.1);
                }
                
                .match-indicator {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    color: white;
                    padding: 4px 8px;
                    border-radius: 12px;
                    font-size: 12px;
                    font-weight: 500;
                }
                
                .match-indicator.exact-match {
                    background: #4CAF50;
                }
                
                .match-indicator.high-match {
                    background: #2196F3;
                }
                
                .match-indicator.medium-match {
                    background: #ff9800;
                }
                
                .match-indicator.low-match {
                    background: #f44336;
                }
                
                .variant-option-image img {
                    border-radius: 8px;
                    object-fit: cover;
                }
                
                .variant-option-content {
                    flex: 1;
                }
                
                .variant-option-title {
                    margin: 0 0 10px 0;
                    color: #2c3e50;
                    font-size: 18px;
                    font-weight: 600;
                }
                
                .variant-option-sku {
                    color: #6c757d;
                    font-size: 14px;
                    margin-bottom: 5px;
                }
                
                .variant-option-inventory {
                    color: #28a745;
                    font-size: 14px;
                    font-weight: 500;
                }
                
                .variant-option-actions {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    min-width: 200px;
                }
                
                .variant-action-buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                
                .no-match-message {
                    text-align: center;
                    padding: 40px;
                    color: #6c757d;
                }
                
                .no-match-message svg {
                    color: #ffc107;
                    margin-bottom: 15px;
                }
                
                .no-match-message h3 {
                    color: #495057;
                    margin-bottom: 10px;
                }
            `)
            .appendTo('head');

        // Create form
        const form = $('<form id="attribute-form"></form>');
        
        // Create steps container
        const stepsContainer = $('<div class="form-steps"></div>');
        
        sortedAttributes.forEach((attribute, index) => {
            const step = createStep(attribute, index);
            stepsContainer.append(step);
            
            // Initially hide optional accessory steps - they'll be shown after required steps are completed
            if (attribute.attributeBehaviour === 'optionalAccessory') {
                step.hide();
                console.log(`Initially hiding optional accessory step: ${attribute.attributeLevel}`);
            }
        });

        // Append steps to form
        form.append(stepsContainer);

        // Create navigation buttons
        const navigation = createNavigation();
        form.append(navigation);

        formContainer.append(form);
    }

    // Create individual step
    function createStep(attribute, index) {
        const step = $('<div>')
            .addClass('form-step')
            .attr('data-step', index);
        
        const stepHeader = $('<div>').addClass('step-header');
        
        // Separate step numbering for required and optional
        let headerText;
        if (attribute.attributeBehaviour === 'optionalAccessory') {
            // For optional accessories, number them separately starting from Step 1
            const optionalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour === 'optionalAccessory'
            );
            const optionalStepNumber = optionalSteps.findIndex(
                attr => attr.attributeLevel === attribute.attributeLevel
            ) + 1;
            headerText = `Step ${optionalStepNumber}: ${attribute.attributeLevel}`;
        } else {
            // Count only non-optional-accessory steps for numbering
            const requiredAndOptionalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour !== 'optionalAccessory'
            );
            const stepNumber = requiredAndOptionalSteps.findIndex(
                attr => attr.attributeLevel === attribute.attributeLevel
            ) + 1;
            headerText = `Step ${stepNumber}: ${attribute.attributeLevel}`;
        }
        
        const headerTitle = $('<h3>').text(headerText);
        stepHeader.append(headerTitle);
        
        const stepContent = $('<div>').addClass('step-content');
        const inputField = createInputField(attribute);
        stepContent.append(inputField);
        
        // For optional steps, show hint that user can skip (unselect) and go to next
        if (attribute.attributeBehaviour === 'optional' || attribute.attributeBehaviour === 'optionalAccessory') {
            const optionalHint = $('<p>')
                .addClass('optional-step-hint')
                .css({ marginTop: '8px', fontSize: '13px', color: '#6c757d', fontStyle: 'italic' })
                .text('Optional – select an option or click Next to skip.');
            stepContent.append(optionalHint);
        }
        
        // Add validation message element
        const validationMessage = $('<div>')
            .addClass('validation-message')
            .text('This configuration is required');
        stepContent.append(validationMessage);
        
        step.append(stepHeader, stepContent);
        
        return step;
    }

    // Create input field based on attribute type
    function createInputField(attribute) {
        console.log(`\n🎨 createInputField called for:`, {
            attributeLevel: attribute.attributeLevel,
            attributeBehaviour: attribute.attributeBehaviour,
            isOptionalAccessory: attribute.attributeBehaviour === 'optionalAccessory',
            optionsCount: attribute.options.length,
            options: attribute.options.map(o => ({ key: o.key, name: o.name }))
        });
        
        const options = attribute.options.sort((a, b) => a.sorting - b.sorting);
        
        // Get available values from variants to mark which options should be enabled/disabled
        const availableValues = getAvailableValuesFromVariants(
            attribute.attributeLevel, 
            attribute.attributeBehaviour === 'optionalAccessory'
        );
        
        // Store available values on the attribute for later use in field creation
        attribute._availableValues = availableValues;
        
        console.log(`  📊 Summary for "${attribute.attributeLevel}":`, {
            totalOptions: options.length,
            availableValuesCount: availableValues !== null ? availableValues.length : 'null',
            availableValues: availableValues,
            optionsList: options.map(o => o.key)
        });
        
        switch(attribute.attributeType) {
            case 'dropdown':
                return createDropdownField(attribute, options);
            case 'toggle':
                return createToggleField(attribute, options);
            case 'checkbox':
                return createCheckboxField(attribute, options);
            default:
                return createDropdownField(attribute, options);
        }
    }

    // Create dropdown field
    function createDropdownField(attribute, options) {
        const select = $('<select>')
            .addClass('form-control')
            .attr('data-attribute', attribute.attributeLevel)
            .attr('data-required', attribute.attributeBehaviour === 'required');
        
        // Add default option
        select.append($('<option>').val('').text(`Select ${attribute.attributeLevel}`));
        
        // Get available values from variants
        const availableValues = attribute._availableValues;
        
        // Add options with proper value handling
        options.forEach((option, index) => {
            console.log(`\n  🔧 Processing option ${index + 1}/${options.length}:`, {
                key: option.key,
                name: option.name,
                availableValues: availableValues,
                availableValuesType: typeof availableValues,
                availableValuesIsArray: Array.isArray(availableValues)
            });
            
            const $option = $('<option>').val(option.key).text(option.name);
            
            // Use same logic for all options (required and optional) - disable if value doesn't exist in variants
            const isOptionalAccessory = attribute.attributeBehaviour === 'optionalAccessory';
            
            if (availableValues !== null && availableValues.length > 0) {
                // Check if this option value exists in available values (case-insensitive check)
                const comparisons = availableValues.map(av => ({
                    exact: av === option.key,
                    exactLower: av.toLowerCase() === option.key.toLowerCase(),
                    nameExact: av === option.name,
                    nameLower: av.toLowerCase() === option.name.toLowerCase(),
                    value: av
                }));
                
                console.log(`    🔍 Comparison results:`, {
                    optionKey: option.key,
                    optionName: option.name,
                    comparisons: comparisons
                });
                
                const optionExists = availableValues.some(av => 
                    av === option.key || 
                    av.toLowerCase() === option.key.toLowerCase() ||
                    av === option.name ||
                    av.toLowerCase() === option.name.toLowerCase()
                );
                
                console.log(`    📊 optionExists result:`, optionExists);
                
                if (!optionExists) {
                    $option.prop('disabled', true).addClass('unavailable');
                    console.log(`    ❌ DISABLING "${option.key}" for "${attribute.attributeLevel}" - not found in ${isOptionalAccessory ? 'optional' : 'required'} variants`);
                    console.log(`       Available values were:`, JSON.stringify(availableValues));
                    console.log(`       Option key was: "${option.key}"`);
                    console.log(`       Option name was: "${option.name}"`);
                } else {
                    console.log(`    ✅ ENABLING "${option.key}" for "${attribute.attributeLevel}" - found in variants`);
                }
            } else if (availableValues !== null && availableValues.length === 0) {
                // No variants exist for this attribute - disable all options
                $option.prop('disabled', true).addClass('unavailable');
                console.log(`    ❌ DISABLING "${option.key}" for "${attribute.attributeLevel}" - no variants exist for this attribute`);
            } else {
                console.log(`    ⚠️ availableValues is null - not disabling (no API data)`);
            }
            
            // Log final state BEFORE appending
            const isDisabledBefore = $option.prop('disabled');
            const hasUnavailableBefore = $option.hasClass('unavailable');
            console.log(`    📌 Final state BEFORE append for "${option.key}":`, {
                disabled: isDisabledBefore,
                hasUnavailableClass: hasUnavailableBefore,
                optionValue: $option.val(),
                optionText: $option.text()
            });
            
            select.append($option);
            
            // Verify state AFTER appending (in case something changes it)
            setTimeout(() => {
                const isDisabledAfter = $option.prop('disabled');
                const hasUnavailableAfter = $option.hasClass('unavailable');
                if (isDisabledBefore !== isDisabledAfter || hasUnavailableBefore !== hasUnavailableAfter) {
                    console.warn(`    ⚠️ STATE CHANGED for "${option.key}" after append!`, {
                        disabledBefore: isDisabledBefore,
                        disabledAfter: isDisabledAfter,
                        unavailableBefore: hasUnavailableBefore,
                        unavailableAfter: hasUnavailableAfter
                    });
                }
            }, 100);
        });
        
        return select;
    }

    // Create toggle field
    function createToggleField(attribute, options) {
        const toggleGroup = $('<div>').addClass('toggle-group');
        
        // Get available values from variants
        const availableValues = attribute._availableValues;
        
        // Add options with proper value handling
        options.forEach(option => {
            const label = $('<label>').addClass('toggle-option');
            const input = $('<input>')
                .attr('type', 'radio')
                .attr('name', attribute.attributeLevel)
                .val(option.key)
                .attr('data-required', attribute.attributeBehaviour === 'required');
            const span = $('<span>').addClass('toggle-label').text(option.name);
            
            // Disable option if it doesn't exist in variants
            if (availableValues !== null && availableValues.length > 0) {
                const optionExists = availableValues.some(av => 
                    av === option.key || 
                    av.toLowerCase() === option.key.toLowerCase() ||
                    av === option.name ||
                    av.toLowerCase() === option.name.toLowerCase()
                );
                
                if (!optionExists) {
                    input.prop('disabled', true).addClass('unavailable');
                    label.addClass('unavailable');
                    console.log(`  ❌ Disabling "${option.key}" for "${attribute.attributeLevel}" - not found in variants`);
                } else {
                    console.log(`  ✅ Enabling "${option.key}" for "${attribute.attributeLevel}" - found in variants`);
                }
            } else if (availableValues !== null && availableValues.length === 0) {
                // No variants exist - disable all options
                input.prop('disabled', true).addClass('unavailable');
                label.addClass('unavailable');
                console.log(`  ❌ Disabling "${option.key}" for "${attribute.attributeLevel}" - no variants exist`);
            }
            
            label.append(input, span);
            toggleGroup.append(label);
        });
        
        // Add "No" option for TOGGLE type attributes
        const noLabel = $('<label>').addClass('toggle-option');
        const noInput = $('<input>')
            .attr('type', 'radio')
            .attr('name', attribute.attributeLevel)
            .val('no')
            .attr('data-required', attribute.attributeBehaviour === 'required');
        const noSpan = $('<span>').addClass('toggle-label').text('No');
        
        // Disable "No" option if it doesn't exist in variants
        if (availableValues !== null && availableValues.length > 0) {
            const noExists = availableValues.some(av => 
                av === 'No' || 
                av === 'no' ||
                av.toLowerCase() === 'no'
            );
            
            if (!noExists) {
                noInput.prop('disabled', true).addClass('unavailable');
                noLabel.addClass('unavailable');
                console.log(`  ❌ Disabling "No" for "${attribute.attributeLevel}" - not found in variants`);
            } else {
                console.log(`  ✅ Enabling "No" for "${attribute.attributeLevel}" - found in variants`);
            }
        } else if (availableValues !== null && availableValues.length === 0) {
            // No variants exist - disable "No"
            noInput.prop('disabled', true).addClass('unavailable');
            noLabel.addClass('unavailable');
            console.log(`  ❌ Disabling "No" for "${attribute.attributeLevel}" - no variants exist`);
        }
        
        noLabel.append(noInput, noSpan);
        toggleGroup.append(noLabel);
        
        return toggleGroup;
    }

    // Create checkbox field
    function createCheckboxField(attribute, options) {
        const checkboxGroup = $('<div>').addClass('checkbox-group');
        
        // Get available values from variants
        const availableValues = attribute._availableValues;
        
        // Add options with proper value handling
        options.forEach(option => {
            const label = $('<label>').addClass('checkbox-option');
            const input = $('<input>')
                .attr('type', 'checkbox')
                .attr('name', attribute.attributeLevel)
                .val(option.key)
                .attr('data-required', attribute.attributeBehaviour === 'required');
            const span = $('<span>').addClass('checkbox-label').text(option.name);
            
            // Disable option if it doesn't exist in variants
            if (availableValues !== null && !availableValues.includes(option.key)) {
                input.prop('disabled', true).addClass('unavailable');
                label.addClass('unavailable');
            }
            
            label.append(input, span);
            checkboxGroup.append(label);
        });
        
        return checkboxGroup;
    }

    // Create navigation buttons
    function createNavigation() {
        return $(`
            <div class="form-navigation">
                <button type="button" class="btn btn-prev" id="prev-btn">Previous</button>
                <button type="button" class="btn btn-next" id="next-btn">Next</button>
                <button type="submit" class="btn btn-submit" id="submit-btn" style="display: none;">Submit</button>
            </div>
        `);
    }

    // Show specific step
    function showStep(stepIndex) {
        // Hide ALL steps first - ensure only one step is visible at a time
        $('.form-step').hide();
        
        // Only show the requested step if it exists and is valid
        if (stepIndex >= 0 && stepIndex < sortedAttributes.length) {
            const currentAttribute = sortedAttributes[stepIndex];
            const $stepElement = $(`.form-step[data-step="${stepIndex}"]`);
            
            // If trying to show an optional accessory step, check if it's available and all required steps are completed
            if (currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory') {
                const requiredAndOptionalSteps = sortedAttributes.filter(
                    attr => attr.attributeBehaviour !== 'optionalAccessory'
                );
                
                // Count completed required steps
                let completedRequiredSteps = 0;
                requiredAndOptionalSteps.forEach((attribute) => {
                    const stepIdx = sortedAttributes.findIndex(a => a.attributeLevel === attribute.attributeLevel);
                    if (isStepCompleted(stepIdx)) {
                        completedRequiredSteps++;
                    }
                });
                
                const allRequiredStepsCompleted = completedRequiredSteps === requiredAndOptionalSteps.length;
                
                if (!allRequiredStepsCompleted) {
                    console.log(`Cannot show optional accessory step - not all required steps completed (${completedRequiredSteps}/${requiredAndOptionalSteps.length})`);
                    return;
                }
                
                // Check if this optional accessory step is marked as available
                const isAvailable = $stepElement.attr('data-available') === 'true';
                if (!isAvailable) {
                    console.log(`Cannot show optional accessory step - not marked as available`);
                    return;
                }
            }
            
            if ($stepElement.length > 0) {
                // Show this step only
                $stepElement.show();
                currentStep = stepIndex;
                console.log(`Showing step ${stepIndex}: ${currentAttribute?.attributeLevel}`);
                
                // Show/hide section headers based on current step type
                if (currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory') {
                    // Showing optional step - show optional section header, hide required section header
                    $('.optional-section').show();
                    $('.required-section').hide();
                } else {
                    // Showing required step - show required section header, hide optional section header
                    $('.required-section').show();
                    $('.optional-section').hide();
                }
            } else {
                console.warn(`Step element not found for index ${stepIndex}`);
                return;
            }
        } else {
            console.warn(`Invalid step index: ${stepIndex}`);
            return;
        }
        
        updateNavigationButtons();
        updateProgressBar();
        
        // Update current step title (storeTitle) - displayed below section headers
        const currentAttribute = sortedAttributes[stepIndex];
        const storeTitle = currentAttribute && currentAttribute.storeTitle ? currentAttribute.storeTitle : '';
        $('.current-step-title').text(storeTitle);
        
        // Update option availability when navigating to a step (in case selections changed)
        if (hasAnySelection()) {
            updateOptionAvailability();
        }
        
        // If showing optional accessory step, display variants for current selections
        if (currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory') {
            console.log('Showing optional accessory step, displaying variants');
            const currentFormData = collectFormData();
            filterAndDisplayVariants(currentFormData);
        }
    }

    // Update navigation buttons
    function updateNavigationButtons() {
        const totalSteps = sortedAttributes.length;
        const currentAttribute = sortedAttributes[currentStep];
        
        // Get required/optional steps (excluding optional accessories)
        const requiredAndOptionalSteps = sortedAttributes.filter(
            attr => attr.attributeBehaviour !== 'optionalAccessory'
        );
        
        // Check if current step is an optional accessory
        const isOnOptionalAccessory = currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory';
        
        // Check if current step is the last required step (step 5)
        const isLastRequiredStep = currentAttribute && 
            currentAttribute.attributeBehaviour !== 'optionalAccessory' &&
            requiredAndOptionalSteps.length > 0 &&
            requiredAndOptionalSteps[requiredAndOptionalSteps.length - 1].attributeLevel === currentAttribute.attributeLevel;
        
        // Check if there are any visible steps after current
        let hasVisibleNextStep = false;
        
        if (isOnOptionalAccessory) {
            // On optional accessory step - check if there are more optional accessories available
            for (let i = currentStep + 1; i < totalSteps; i++) {
                const nextAttribute = sortedAttributes[i];
                if (nextAttribute && nextAttribute.attributeBehaviour === 'optionalAccessory') {
                    const $nextStepElement = $(`.form-step[data-step="${i}"]`);
                    const isAvailable = $nextStepElement.attr('data-available') === 'true';
                    if (isAvailable) {
                        hasVisibleNextStep = true;
                        break;
                    }
                }
            }
        } else if (isLastRequiredStep) {
            // On last required step - check if there's an optional accessory step available
            for (let i = currentStep + 1; i < totalSteps; i++) {
                const nextAttribute = sortedAttributes[i];
                if (nextAttribute && nextAttribute.attributeBehaviour === 'optionalAccessory') {
                    const $nextStepElement = $(`.form-step[data-step="${i}"]`);
                    const isAvailable = $nextStepElement.attr('data-available') === 'true';
                    if (isAvailable) {
                        hasVisibleNextStep = true;
                        break;
                    }
                }
            }
        } else {
            // For other required steps, check if there are more required steps
            const currentRequiredIndex = requiredAndOptionalSteps.findIndex(
                attr => attr.attributeLevel === currentAttribute.attributeLevel
            );
            hasVisibleNextStep = currentRequiredIndex >= 0 && currentRequiredIndex < requiredAndOptionalSteps.length - 1;
        }
        
        $('#prev-btn').toggle(currentStep > 0);
        $('#next-btn').toggle(hasVisibleNextStep);
        $('#submit-btn').toggle(!hasVisibleNextStep);
        
        console.log('Navigation buttons updated:', {
            currentStep,
            isOnOptionalAccessory,
            isLastRequiredStep,
            hasVisibleNextStep,
            showSubmit: !hasVisibleNextStep
        });
    }

    // Update progress bar
    function updateProgressBar() {
        const currentAttribute = sortedAttributes[currentStep];
        const isOnOptionalAccessory = currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory';
        
        let totalSteps, completedSteps, progress, stepsToShow;
        
        if (isOnOptionalAccessory) {
            // Show optional step indicators
            const optionalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour === 'optionalAccessory'
            );
            totalSteps = optionalSteps.length;
            
            let completedOptionalSteps = 0;
            optionalSteps.forEach((attr) => {
                const stepIndex = sortedAttributes.findIndex(a => a.attributeLevel === attr.attributeLevel);
                if (isStepCompleted(stepIndex)) {
                    completedOptionalSteps++;
                }
            });
            completedSteps = completedOptionalSteps;
            progress = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;
            stepsToShow = optionalSteps;
        } else {
            // Show required step indicators
            const requiredAndOptionalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour !== 'optionalAccessory'
            );
            totalSteps = requiredAndOptionalSteps.length;
            completedSteps = getCompletedStepsCount();
            progress = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;
            stepsToShow = requiredAndOptionalSteps;
        }
        
        // Update progress bar width with smooth animation
        $('.progress-fill').css('width', progress + '%');
        
        // Update step indicators
        $('.step-indicators').empty();
        stepsToShow.forEach((attribute) => {
            const i = sortedAttributes.findIndex(a => a.attributeLevel === attribute.attributeLevel);
            
            let status = '';
            if (isStepCompleted(i)) {
                status = 'completed';
            } else if (i === currentStep) {
                status = 'current';
            } else {
                status = 'pending';
            }
            
            // Find the step number within the current section
            const stepNumber = stepsToShow.findIndex(
                attr => attr.attributeLevel === attribute.attributeLevel
            ) + 1;
            
            const indicator = $(`<span class="step-indicator ${status}" data-step="${i}" title="Step ${stepNumber}: ${attribute.attributeLevel}"></span>`);
            $('.step-indicators').append(indicator);
        });
        
        // Update progress bar color based on completion
        updateProgressBarColor(progress);
        
        // Add visual feedback for progress changes
        $('.progress-fill').addClass('progress-updated');
        setTimeout(() => {
            $('.progress-fill').removeClass('progress-updated');
        }, 300);
    }

    // Get count of completed steps (only non-optional-accessory steps)
    function getCompletedStepsCount() {
        let completedCount = 0;
        
        sortedAttributes.forEach((attribute, index) => {
            // Skip optional accessories in completion count
            if (attribute.attributeBehaviour === 'optionalAccessory') {
                return;
            }
            
            if (isStepCompleted(index)) {
                completedCount++;
            }
        });
        
        return completedCount;
    }

    // Check if a specific step is completed
    function isStepCompleted(stepIndex) {
        const stepElement = $(`.form-step[data-step="${stepIndex}"]`);
        const attribute = sortedAttributes[stepIndex];
        
        if (!stepElement.length) return false;
        
        let isCompleted = false;
        
        if (attribute.attributeType === 'dropdown') {
            isCompleted = stepElement.find('select').val() !== '';
        } else if (attribute.attributeType === 'toggle') {
            isCompleted = stepElement.find(`input[name="${attribute.attributeLevel}"]:checked`).length > 0;
        } else if (attribute.attributeType === 'checkbox') {
            isCompleted = stepElement.find(`input[name="${attribute.attributeLevel}"]:checked`).length > 0;
        }
        
        return isCompleted;
    }

    // Update progress bar color based on completion percentage
    function updateProgressBarColor(progress) {
        const progressFill = $('.progress-fill');
        
        if (progress >= 80) {
            progressFill.removeClass('progress-low progress-medium progress-high').addClass('progress-complete');
        } else if (progress >= 60) {
            progressFill.removeClass('progress-low progress-medium progress-complete').addClass('progress-high');
        } else if (progress >= 40) {
            progressFill.removeClass('progress-low progress-complete progress-high').addClass('progress-medium');
        } else {
            progressFill.removeClass('progress-medium progress-high progress-complete').addClass('progress-low');
        }
    }

    // Update progress statistics
    function updateProgressStats() {
        const currentAttribute = sortedAttributes[currentStep];
        const isOnOptionalAccessory = currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory';
        
        if (isOnOptionalAccessory) {
            // Show optional step progress
            const optionalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour === 'optionalAccessory'
            );
            const totalOptionalSteps = optionalSteps.length;
            
            let completedOptionalSteps = 0;
            optionalSteps.forEach((attr, index) => {
                const stepIndex = sortedAttributes.findIndex(a => a.attributeLevel === attr.attributeLevel);
                if (isStepCompleted(stepIndex)) {
                    completedOptionalSteps++;
                }
            });
            
            const currentOptionalStepNumber = optionalSteps.findIndex(
                attr => attr.attributeLevel === currentAttribute.attributeLevel
            ) + 1;
            
            $('.completed-steps').text(currentOptionalStepNumber);
            $('.total-steps').text(totalOptionalSteps);
            $('.progress-label').text('optional questions');
        } else {
            // Show required step progress
            const completedSteps = getCompletedStepsCount();
            // Only count non-optional-accessory steps in total
            const totalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour !== 'optionalAccessory'
            ).length;
            
            $('.completed-steps').text(completedSteps);
            $('.total-steps').text(totalSteps);
            $('.progress-label').text('questions completed');
        }
    }

    // Validate current step
    function validateStep(stepIndex, showMessage = false) {
        const attribute = sortedAttributes[stepIndex];
        // Optional and optionalAccessory steps are skippable: user can go to next without selecting anything
        if (attribute && (attribute.attributeBehaviour === 'optional' || attribute.attributeBehaviour === 'optionalAccessory')) {
            const validationMessage = $(`.form-step[data-step="${stepIndex}"]`).find('.validation-message');
            if (showMessage) validationMessage.removeClass('show');
            return true;
        }

        const currentStepElement = $(`.form-step[data-step="${stepIndex}"]`);
        const inputs = currentStepElement.find('input, select');
        const validationMessage = currentStepElement.find('.validation-message');
        let isValid = true;
        
        inputs.each(function() {
            const input = $(this);
            const isRequired = input.data('required');
            
            if (isRequired) {
                if (input.is('select')) {
                    if (!input.val()) {
                        isValid = false;
                    }
                } else if (input.is('input[type="radio"]')) {
                    const name = input.attr('name');
                    if (!currentStepElement.find(`input[name="${name}"]:checked`).length) {
                        isValid = false;
                    }
                } else if (input.is('input[type="checkbox"]')) {
                    const name = input.attr('name');
                    if (!currentStepElement.find(`input[name="${name}"]:checked`).length) {
                        isValid = false;
                    }
                }
            }
        });
        
        // Show or hide validation message only if showMessage is true
        if (showMessage) {
            if (!isValid) {
                validationMessage.addClass('show');
            } else {
                validationMessage.removeClass('show');
            }
        }
        
        return isValid;
    }

    // Collect form data
    function collectFormData() {
        formData = {};
        
        sortedAttributes.forEach((attribute, index) => {
            const stepElement = $(`.form-step[data-step="${index}"]`);
            
            if (attribute.attributeType === 'dropdown') {
                formData[attribute.attributeLevel] = stepElement.find('select').val();
            } else if (attribute.attributeType === 'toggle') {
                const selected = stepElement.find(`input[name="${attribute.attributeLevel}"]:checked`);
                formData[attribute.attributeLevel] = selected.length ? selected.val() : null;
            } else if (attribute.attributeType === 'checkbox') {
                const selected = stepElement.find(`input[name="${attribute.attributeLevel}"]:checked`);
                formData[attribute.attributeLevel] = selected.map(function() {
                    return $(this).val();
                }).get();
            }
        });
        
        return formData;
    }

    // Event handlers
    $(document).on('click', '#prev-btn', function() {
        if (currentStep > 0) {
            showStep(currentStep - 1);
        }
    });

    // Helper function to check if any selections have been made
    function hasAnySelection() {
        const currentFormData = collectFormData();
        for (const [key, value] of Object.entries(currentFormData)) {
            if (value && value !== '' && value !== null) {
                if (Array.isArray(value) && value.length > 0) {
                    return true;
                } else if (!Array.isArray(value)) {
                    return true;
                }
            }
        }
        return false;
    }

    // Function to filter and display variants based on form data
    function filterAndDisplayVariants(formData) {
        const matchingVariants = getMatchingVariants(formData);
        
        // Check if all steps are completed
        const allStepsCompleted = sortedAttributes.every((attribute, index) => {
            const stepElement = $(`.form-step[data-step="${index}"]`);
            const attributeName = attribute.attributeLevel;
            const formValue = formData[attributeName];
            
            if (attribute.attributeBehaviour === 'required') {
                // Required fields must have a value
                return formValue && formValue !== '' && formValue !== null;
            } else {
                // Optional fields are considered "completed" even if empty
                return true;
            }
        });
        
        if (matchingVariants.length > 0) {
            // Show the "Select Title" section and variant list container
            $('.product__config-option').addClass('variants-visible');
            $('.product__config-option-values-list').addClass('variants-visible');
            
            // Get matching variant IDs in display order (primary first, then optional); skip entries with missing variant/shopifyVariantId
            const matchingVariantIds = matchingVariants
                .filter(m => m.variant && m.variant.shopifyVariantId != null)
                .map(m => m.variant.shopifyVariantId.toString());
            
            const $mainList = $('.product__config-option-values-list:not(.accessory-items)');
            const $accessoryListForShow = $('.product__config-option-values-list.accessory-items');
            
            // Show matching variants, hide others (main list and accessory list)
            function setFiltered($list) {
                $list.find('.product__config-option-value').each(function() {
                    const $elem = $(this);
                    const variantId = $elem.find('.product__config-option-value-input').attr('name')?.match(/\[(\d+)\]/)?.[1];
                    if (variantId && matchingVariantIds.includes(variantId)) {
                        $elem.addClass('filtered').removeClass('variant-hidden');
                    } else {
                        $elem.removeClass('filtered').addClass('variant-hidden');
                    }
                });
            }
            setFiltered($mainList);
            setFiltered($accessoryListForShow);
            if (matchingVariantIds.some(id => $accessoryListForShow.find('.product__config-option-value-input[name="options[' + id + ']"]').length)) {
                $accessoryListForShow.addClass('variants-visible').closest('.product__config-option-values').addClass('variants-visible');
            }
            
            // Reorder DOM so primary (required) is first, then optional – user sees primary at top
            const sortedIds = matchingVariantIds;
            // Prepend in reverse order so first in list ends up at top: primary first, then optional
            for (let i = sortedIds.length - 1; i >= 0; i--) {
                const id = sortedIds[i];
                const $variantEl = $mainList.find('.product__config-option-value .product__config-option-value-input[name="options[' + id + ']"]').closest('.product__config-option-value');
                if ($variantEl.length) {
                    $variantEl.prependTo($mainList);
                }
            }
            // Move non-matching variants to the end (still hidden)
            $mainList.find('.product__config-option-value').each(function() {
                const $elem = $(this);
                const variantId = $elem.find('.product__config-option-value-input').attr('name')?.match(/\[(\d+)\]/)?.[1];
                if (variantId && !sortedIds.includes(variantId)) {
                    $elem.appendTo($mainList);
                }
            });
            
            // Split into "Required product" and "Optional accessories" sections with headers
            const requiredIds = matchingVariants
                .filter(m => m.matchType === 'required' && m.variant && m.variant.shopifyVariantId != null)
                .map(m => m.variant.shopifyVariantId.toString());
            const optionalIds = matchingVariants
                .filter(m => (m.matchType === 'optional' || m.matchType === 'nearest') && m.variant && m.variant.shopifyVariantId != null)
                .map(m => m.variant.shopifyVariantId.toString());
            const isNearestMatch = matchingVariants.some(m => m.isNearestMatch);
            
            $mainList.find('.product__config-required-section, .product__config-optional-section').remove();
            
            // Optional accessories section must appear BELOW Required/Nearest – prepend optional first, then required (so required is first in DOM = on top)
            const $accessoryList = $('.product__config-option-values-list.accessory-items');
            const $anyList = $mainList.add($accessoryList);
            
            if (optionalIds.length > 0) {
                const optionalTitle = isNearestMatch ? 'Nearest match (optional accessories)' : 'Optional accessories';
                const $optionalSection = $('<div class="product__config-optional-section"></div>');
                $optionalSection.append($('<h4 class="product__config-section-title product__config-section-title--optional">').text(optionalTitle));
                optionalIds.forEach(function(id) {
                    const $el = $anyList.find('.product__config-option-value .product__config-option-value-input[name="options[' + id + ']"]').closest('.product__config-option-value');
                    if ($el.length) { $el.appendTo($optionalSection); }
                });
                $mainList.prepend($optionalSection);
            }
            if (requiredIds.length > 0) {
                const requiredTitle = 'Required product';
                const $requiredSection = $('<div class="product__config-required-section product__config-section--primary"></div>');
                $requiredSection.append($('<h4 class="product__config-section-title product__config-section-title--primary">').text(requiredTitle));
                requiredIds.forEach(function(id) {
                    const $el = $anyList.find('.product__config-option-value .product__config-option-value-input[name="options[' + id + ']"]').closest('.product__config-option-value');
                    if ($el.length) { $el.appendTo($requiredSection); }
                });
                $mainList.prepend($requiredSection);
            }
            
            // Phase 3: Show message when all steps completed
            if (allStepsCompleted) {
                if (matchingVariants.length === 1) {
                    console.log('✅ Perfect match! Only 1 product matches all selections');
                    // Optionally show a success message or highlight the single variant
                } else if (matchingVariants.length === 0) {
                    console.log('⚠️ No products match all selections');
                } else {
                    console.log(`ℹ️ ${matchingVariants.length} products match all selections`);
                }
            }
            
            console.log(`✅ Showing ${matchingVariants.length} matching variants`);
        } else {
            // No matches - hide all variants and "Select Title" section
            $('.product__config-option').removeClass('variants-visible');
            $('.product__config-option-values-list').removeClass('variants-visible');
            $('.product__config-option-values-list .product__config-option-value').removeClass('filtered').addClass('variant-hidden');
            console.log('⚠️ No matching variants found');
        }
    }

    // Update progress when form inputs change
    $(document).on('change', 'select, input[type="radio"], input[type="checkbox"]', function() {
        updateProgressBar();
        updateProgressStats();
        
        // Hide validation message when user makes a selection
        const stepElement = $(this).closest('.form-step');
        const validationMessage = stepElement.find('.validation-message');
        if ($(this).val()) {
            validationMessage.removeClass('show');
        }
        
        // Get current form data
        const currentFormData = collectFormData();
        
        // Check if we're on an optional accessory step
        const currentAttribute = sortedAttributes[currentStep];
        const isOnOptionalAccessory = currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory';
        
        // ALWAYS ensure all optional accessory steps are hidden EXCEPT the current one if we're on it
        sortedAttributes.forEach((attribute, stepIndex) => {
            if (attribute.attributeBehaviour === 'optionalAccessory') {
                // Hide all optional accessory steps except the current one
                if (stepIndex !== currentStep) {
                    $(`.form-step[data-step="${stepIndex}"]`).hide();
                }
            }
        });
        
        // Phase 1: Filter variants based on selections
        if (hasAnySelection()) {
            // Show variant list and filter variants
            filterAndDisplayVariants(currentFormData);
            
            // If on optional accessory step, ensure variants are displayed
            if (isOnOptionalAccessory) {
                console.log('Optional accessory selected, displaying variants');
                filterAndDisplayVariants(currentFormData);
            }
            
            // Phase 3: Check and update option availability for remaining steps
            updateOptionAvailability();
            
            // Update navigation buttons (submit button should show after optional accessory if we're on it)
            if (isOnOptionalAccessory) {
                updateNavigationButtons();
            }
        } else {
            // Hide all variants and "Select Title" section if no selections
            $('.product__config-option').removeClass('variants-visible');
            $('.product__config-option-values-list').removeClass('variants-visible');
            $('.product__config-option-values-list .product__config-option-value').removeClass('filtered').addClass('variant-hidden');
            
            // Reset all options to enabled when no selections
            $('.form-step select option, .form-step input[type="radio"], .form-step input[type="checkbox"]')
                .prop('disabled', false)
                .removeClass('unavailable');
            $('.form-step label').removeClass('unavailable');
        }
    });

    // Allow clicking on step indicators with validation (silent - no alerts)
    $(document).on('click', '.step-indicator', function() {
        const stepIndex = $(this).data('step');
        
        if (stepIndex === undefined || stepIndex === currentStep) {
            return;
        }
        
        // Allow going backwards without validation
        if (stepIndex < currentStep) {
            showStep(stepIndex);
            return;
        }
        
        // For forward navigation, validate all steps between current and target
        let canNavigate = true;
        for (let i = currentStep; i < stepIndex; i++) {
            if (!validateStep(i)) {
                canNavigate = false;
                break;
            }
        }
        
        // Only navigate if validation passed (silent blocking)
        if (canNavigate) {
            showStep(stepIndex);
        }
    });

    $(document).on('click', '#next-btn', function() {
        console.log('Next button clicked, current step:', currentStep);
        
        // Validate and show message if invalid
        if (validateStep(currentStep, true)) {
            console.log('Step validation passed');
            
            // Get required/optional steps (excluding optional accessories)
            const requiredAndOptionalSteps = sortedAttributes.filter(
                attr => attr.attributeBehaviour !== 'optionalAccessory'
            );
            const currentAttribute = sortedAttributes[currentStep];
            
            // Check if we just completed the last required step (step 5, which is index 4 in 0-based)
            const isLastRequiredStep = currentAttribute && 
                currentAttribute.attributeBehaviour !== 'optionalAccessory' &&
                requiredAndOptionalSteps[requiredAndOptionalSteps.length - 1].attributeLevel === currentAttribute.attributeLevel;
            
            console.log('Is last required step:', isLastRequiredStep, 'Current attribute:', currentAttribute?.attributeLevel);
            
            if (isLastRequiredStep) {
                // Just completed the last required step (step 5), check if we should show optional accessory
                console.log('Completed last required step, checking for optional accessories...');
                
                const currentFormData = collectFormData();
                
                // Trigger the check to mark optional accessories as available
                updateOptionAvailability();
                
                // Small delay to ensure DOM is updated
                setTimeout(() => {
                    // Find next optional accessory step that is available
                    let nextStep = currentStep + 1;
                    let foundOptionalStep = false;
                    
                    while (nextStep < sortedAttributes.length) {
                        const $nextStepElement = $(`.form-step[data-step="${nextStep}"]`);
                        const nextAttribute = sortedAttributes[nextStep];
                        
                        if (nextAttribute && nextAttribute.attributeBehaviour === 'optionalAccessory') {
                            const isAvailable = $nextStepElement.attr('data-available') === 'true';
                            if (isAvailable) {
                                showStep(nextStep);
                                filterAndDisplayVariants(currentFormData);
                                foundOptionalStep = true;
                                return;
                            }
                        }
                        nextStep++;
                    }
                    
                    if (!foundOptionalStep) {
                        filterAndDisplayVariants(currentFormData);
                        updateNavigationButtons();
                    }
                }, 100);
            } else {
                // Check if we're on an optional accessory step
                const isOnOptionalAccessory = currentAttribute && currentAttribute.attributeBehaviour === 'optionalAccessory';
                
                if (isOnOptionalAccessory) {
                    // On optional accessory step - find next optional accessory step
                    let nextStep = currentStep + 1;
                    
                    while (nextStep < sortedAttributes.length) {
                        const nextAttribute = sortedAttributes[nextStep];
                        const $nextStepElement = $(`.form-step[data-step="${nextStep}"]`);
                        
                        if (nextAttribute && nextAttribute.attributeBehaviour === 'optionalAccessory') {
                            const isAvailable = $nextStepElement.attr('data-available') === 'true';
                            if (isAvailable) {
                                showStep(nextStep);
                                return;
                            }
                        }
                        nextStep++;
                    }
                    
                    updateNavigationButtons();
                } else {
                    // Not the last required step, go to next required step
                    const currentRequiredIndex = requiredAndOptionalSteps.findIndex(
                        attr => attr.attributeLevel === currentAttribute.attributeLevel
                    );
                    
                    if (currentRequiredIndex >= 0 && currentRequiredIndex < requiredAndOptionalSteps.length - 1) {
                        // Find the next required step in sortedAttributes
                        const nextRequiredAttribute = requiredAndOptionalSteps[currentRequiredIndex + 1];
                        const nextStepIndex = sortedAttributes.findIndex(
                            attr => attr.attributeLevel === nextRequiredAttribute.attributeLevel
                        );
                        
                        console.log('Going to next required step:', nextStepIndex);
                        if (nextStepIndex >= 0) {
                            showStep(nextStepIndex);
                            return;
                        }
                    }
                }
                
                // Fallback: find next visible step
                let nextStep = currentStep + 1;
                while (nextStep < sortedAttributes.length) {
                    const $nextStepElement = $(`.form-step[data-step="${nextStep}"]`);
                    if ($nextStepElement.is(':visible')) {
                        console.log('Found next visible step:', nextStep);
                        showStep(nextStep);
                        return;
                    }
                    nextStep++;
                }
            }
        } else {
            console.log('Step validation failed');
        }
        // If validation fails, message will be shown by validateStep
    });

    $(document).on('submit', '#attribute-form', function(e) {
        console.log('Form submitted');
        e.preventDefault();
        
        // Prevent multiple submissions
        if ($(this).data('submitting')) {
            console.log('Form already submitting, ignoring duplicate submission');
            return;
        }
        
        // Validate the current step before submission and show message if invalid
        if (!validateStep(currentStep, true)) {
            return; // Prevent submission if not valid
        }
        
        $(this).data('submitting', true);
        
        const finalData = collectFormData();
        console.log('Form submitted with data:', finalData);
        
        // Filter and display variants in existing DOM (Required product + Optional accessories)
        filterAndDisplayVariants(finalData);
        
        // Ensure variant list area is visible and scroll to it
        $('.product__config-option').addClass('variants-visible');
        $('.product__config-option-values-list').addClass('variants-visible');
        const $variantList = $('.product__config-option-values-list:not(.accessory-items)');
        if ($variantList.length > 0) {
            $variantList.addClass('filter-list');
            const offset = $variantList.first().offset().top - 100;
            $('html, body').animate({ scrollTop: Math.max(0, offset) }, 500);
        }
        
        // Optional: also run displaySelectedVariant (it will skip reorder when list already has sections)
        displaySelectedVariant(finalData);
        $('.variant-selection-display').show();
        
        // Reset submission flag after a delay
        setTimeout(() => {
            $(this).data('submitting', false);
        }, 1000);
    });

    // Get matching variants based on form data and API response
    function getMatchingVariants(formData) {
        const matchingVariants = [];
        
        if (!window.apiProductData || !window.apiProductData.product) {
            return matchingVariants;
        }
        
        const product = window.apiProductData.product;
        const requiredVariants = product.required?.variants || [];
        const optionalVariants = product.optional?.variants || [];
        
        // Separate required and optional selections
        const requiredSelections = {};
        const optionalSelections = {};
        
        // Get attribute info from sortedAttributes
        sortedAttributes.forEach(attr => {
            const attrName = attr.attributeLevel;
            const formValue = formData[attrName];
            
            if (formValue && formValue !== '' && formValue !== null) {
                if (attr.attributeBehaviour === 'required') {
                    requiredSelections[attrName] = formValue;
                } else if (attr.attributeBehaviour === 'optionalAccessory') {
                    optionalSelections[attrName] = formValue;
                }
            }
        });
        
        console.log('🔵 REQUIRED selections (from steps 1-5):', requiredSelections);
        console.log('🟢 OPTIONAL selections (from optional accessory step):', optionalSelections);
        console.log('📊 These are 2 INDEPENDENT forms - required and optional don\'t need to match each other');
        
        // Helper function to check if variant matches selections
        function variantMatchesSelections(variant, selections) {
            const combination = variant.attributeCombination || {};
            for (const [attrName, selectedValue] of Object.entries(selections)) {
                const variantValue = combination[attrName];
                // Handle array values (for multi-select)
                if (Array.isArray(selectedValue)) {
                    if (!selectedValue.includes(variantValue)) {
                        return false;
                    }
                } else if (variantValue !== selectedValue) {
                    return false;
                }
            }
            return true;
        }
        
        // Step 1: Match required variants based on required selections
        const matchingRequiredVariants = requiredVariants.filter(variant => {
            return variantMatchesSelections(variant, requiredSelections);
        });
        
        console.log(`Found ${matchingRequiredVariants.length} matching required variants`);
        
        // Step 2: If optional selections exist, also match optional variants
        let matchingOptionalVariants = [];
        if (Object.keys(optionalSelections).length > 0) {
            matchingOptionalVariants = optionalVariants.filter(variant => {
                return variantMatchesSelections(variant, optionalSelections);
            });
            console.log(`Found ${matchingOptionalVariants.length} matching optional variants`);
        }
        
        // Step 3: Combine variants - show required variants first, then optional only if user made optional selections
        matchingRequiredVariants.forEach(variant => {
            if (variant && variant.shopifyVariantId != null) {
                matchingVariants.push({
                    variant,
                    matchScore: 100,
                    matchType: 'required',
                    isExactMatch: true,
                    isGoodMatch: true,
                    matchPercentage: 100
                });
            }
        });
        
        // Add optional variants only when optional selections exist
        if (Object.keys(optionalSelections).length > 0 && matchingOptionalVariants.length > 0) {
            matchingOptionalVariants.forEach(variant => {
                if (variant && variant.shopifyVariantId != null) {
                    matchingVariants.push({
                        variant,
                        matchScore: 50,
                        matchType: 'optional',
                        isExactMatch: true,
                        isGoodMatch: true,
                        matchPercentage: 50
                    });
                }
            });
        }
        
        // If no match at all, OR user selected optional (e.g. "Yes" on last step) but no optional variant matches: show nearest match, primary first then optional
        const MAX_OPTIONAL_DISPLAY = 5;
        const optionalSelectedButNoMatch = Object.keys(optionalSelections).length > 0 && matchingOptionalVariants.length === 0;
        if (matchingVariants.length === 0 || optionalSelectedButNoMatch) {
            if (optionalSelectedButNoMatch) {
                matchingVariants.length = 0;
            }
            const allSelections = { ...requiredSelections, ...optionalSelections };
            const scoreVariant = (variant) => {
                const combination = variant.attributeCombination || {};
                let matchCount = 0, totalChecked = 0;
                for (const [attrName, selectedValue] of Object.entries(allSelections)) {
                    if (selectedValue == null || selectedValue === '') continue;
                    totalChecked++;
                    const variantValue = combination[attrName];
                    if (Array.isArray(selectedValue)) {
                        if (selectedValue.includes(variantValue)) matchCount++;
                    } else if (variantValue === selectedValue) {
                        matchCount++;
                    }
                }
                const matchPercentage = totalChecked > 0 ? Math.round((matchCount / totalChecked) * 100) : 0;
                return { variant, matchScore: matchPercentage, matchPercentage };
            };
            // Score required and optional separately so we can put primary first, then optional (first 5)
            const scoredRequired = requiredVariants.map(v => ({ ...scoreVariant(v), matchType: 'required' }));
            const scoredOptional = optionalVariants.map(v => ({ ...scoreVariant(v), matchType: 'optional' }));
            scoredRequired.sort((a, b) => b.matchScore - a.matchScore);
            scoredOptional.sort((a, b) => b.matchScore - a.matchScore);
            // Show nearest even when no variant matches (include score 0) – top 1 primary, up to 5 optional
            const nearestRequired = scoredRequired.slice(0, 1);
            const nearestOptional = scoredOptional.slice(0, MAX_OPTIONAL_DISPLAY);
            // Label as nearest so UI can show "Nearest match" instead of "Required product"; skip variants with no shopifyVariantId
            nearestRequired.forEach(r => {
                if (r.variant && r.variant.shopifyVariantId != null) {
                    matchingVariants.push({
                        variant: r.variant,
                        matchScore: r.matchScore,
                        matchType: 'required',
                        isNearestMatch: true,
                        isExactMatch: r.matchScore === 100,
                        isGoodMatch: r.matchScore >= 50,
                        matchPercentage: r.matchScore
                    });
                }
            });
            nearestOptional.forEach(r => {
                if (r.variant && r.variant.shopifyVariantId != null) {
                    matchingVariants.push({
                        variant: r.variant,
                        matchScore: r.matchScore,
                        matchType: 'optional',
                        isNearestMatch: true,
                        isExactMatch: r.matchScore === 100,
                        isGoodMatch: r.matchScore >= 50,
                        matchPercentage: r.matchScore
                    });
                }
            });
            console.log(`⚠️ No exact match; showing nearest: ${nearestRequired.length} primary + ${nearestOptional.length} optional (max ${MAX_OPTIONAL_DISPLAY} optional)`);
        }
        
        // Sort: required first, then optional, then nearest; within type by score
        matchingVariants.sort((a, b) => {
            if (a.matchType === 'required' && b.matchType !== 'required') return -1;
            if (a.matchType !== 'required' && b.matchType === 'required') return 1;
            if (a.matchType === 'optional' && b.matchType === 'nearest') return -1;
            if (a.matchType === 'nearest' && b.matchType === 'optional') return 1;
            return b.matchScore - a.matchScore;
        });
        
        // Primary (required) always first; include optional only when user has made optional selections
        let requiredPart = matchingVariants.filter(m => m.matchType === 'required');
        const optionalPart = matchingVariants.filter(m => m.matchType === 'optional' || m.matchType === 'nearest');
        const hasOptionalSelections = Object.keys(optionalSelections).length > 0;
        let optionalCapped = hasOptionalSelections ? optionalPart.slice(0, MAX_OPTIONAL_DISPLAY) : [];
        // If API returns no required variants (or none match), show first match as Required product so section is not empty
        if (requiredPart.length === 0 && (optionalCapped.length > 0 || matchingVariants.length > 0)) {
            const first = optionalCapped[0] || matchingVariants[0];
            if (first && first.variant && first.variant.shopifyVariantId != null) {
                requiredPart = [{ ...first, matchType: 'required' }];
                optionalCapped = optionalCapped.slice(1);
            }
        }
        const cappedVariants = [...requiredPart, ...optionalCapped];
        
        console.log(`\n✅ FINAL RESULT: ${cappedVariants.length} variant(s) (primary first${hasOptionalSelections ? ', then up to ' + MAX_OPTIONAL_DISPLAY + ' optional' : ' – required only'})`);
        console.log(`   - ${matchingRequiredVariants.length} required (primary) variant(s)`);
        console.log(`   - ${matchingOptionalVariants.length} optional variant(s)`);
        
        return cappedVariants;
    }
    
    // Get variant information for display (returns the best match)
    function getVariantInfo(formData) {
        const matchingVariants = getMatchingVariants(formData);
        
        if (matchingVariants.length > 0) {
            const bestMatch = matchingVariants[0];
            const variant = bestMatch.variant;
            
            return {
                variantId: variant.shopifyVariantId,
                title: variant.name,
                image: variant.image,
                originalPrice: variant.price > 0 ? `$${variant.price.toFixed(2)}` : 'Contact for pricing',
                currentPrice: variant.price > 0 ? `$${variant.price.toFixed(2)}` : 'Contact for pricing',
                sku: variant.sku,
                inventoryQuantity: variant.inventoryQuantity,
                matchPercentage: bestMatch.matchPercentage,
                isExactMatch: bestMatch.isExactMatch
            };
        }
        
        // Fallback if no matching variant found
        return {
            variantId: 'unknown',
            title: 'Custom Configuration',
            image: 'https://socalbiomed.myshopify.com/cdn/shop/files/6ft_protector_premier_hood.jpg',
            originalPrice: 'Contact for pricing',
            currentPrice: 'Contact for pricing',
            sku: 'Custom',
            inventoryQuantity: 0,
            matchPercentage: 0,
            isExactMatch: false
        };
    }
    
    // Get variant specifications based on form data
    function getVariantSpecs(formData) {
        let specs = [];
        
        // Dynamically build specs from form data
        for (const [key, value] of Object.entries(formData)) {
            if (value && value !== '') {
                specs.push(`${key}: ${value}`);
            }
        }
        
        return specs.length > 0 ? specs.join(' • ') : 'Custom Configuration';
    }
    
    // Display selected variant based on form data
    function displaySelectedVariant(formData) {
        console.log('displaySelectedVariant called with data:', formData);
        
        // Remove any existing variant display first
        const existingDisplays = $('.variant-selection-display');
        if (existingDisplays.length > 0) {
            console.log(`Found ${existingDisplays.length} existing variant displays, removing them`);
            existingDisplays.remove();
        }
        
        // Get all matching variants
        const matchingVariants = getMatchingVariants(formData);
        console.log('Matching variants found:', matchingVariants.length, matchingVariants);
        
        const variantInfo = getVariantInfo(formData);
        
        // Create variant selection display
        const variantDisplay = $('<div>').addClass('variant-selection-display').hide();
        
        // Header section
        const header = $('<div>').addClass('variant-selection-header');
        const icon = $('<div>').addClass('variant-selection-icon').html(`
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" fill="currentColor"/>
            </svg>
        `);
        const title = $('<h3>').addClass('variant-selection-title').text('Configuration Selected');
        const subtitle = $('<p>').addClass('variant-selection-subtitle').text(`Based on your selections, we found ${matchingVariants.length} suitable product${matchingVariants.length !== 1 ? 's' : ''}:`);
        
        header.append(icon, title, subtitle);
        variantDisplay.append(header);
        
        // Variants list
        const variantsList = $('<div>').addClass('variants-list');
        
        if (matchingVariants.length > 0) {
            console.log('Displaying', matchingVariants.length, 'matching variants');
            
            // When attribute form already filtered the list (Required/Optional sections), don't overwrite it – just ensure visibility and scroll
            const $existingList = $(`.product__config-option-values-list:not(.accessory-items)`);
            const alreadyFiltered = $existingList.find('.product__config-required-section, .product__config-optional-section').length > 0;
            if ($existingList.length > 0 && alreadyFiltered) {
                console.log('Filtered list already displayed (Required/Optional sections); skipping DOM reorder to avoid overwriting.');
                $existingList.addClass('filter-list');
                $('.product__config-option').addClass('variants-visible');
                $existingList.addClass('variants-visible');
                const offset = $existingList.first().offset().top - 100;
                $('html, body').animate({ scrollTop: offset }, 500);
            } else if ($existingList.length > 0) {
                console.log('Found existing variant list, updating it...');
                $(`.product__config-option-values-list:not(.accessory-items) .product__config-option-value`).removeClass('filtered');
                $existingList.addClass('filter-list');
                $('.product__config-option-values-header').remove();
                $('.product__config-option.active .product__config-option-values')
                .prepend('<div class="product__config-option-values-header"><div class="Filter-text">Maximum matched products</div></div>')
                .end()
                .each(function() {
                    const off = $(this).find('.product__config-option-values-header').first().offset().top - 100;
                    $('html, body').animate({ scrollTop: off }, 500);
                });
                const $list = $(`.product__config-option-values-list:not(.accessory-items)`);
                const sortedVariantIds = matchingVariants.map(m => m.variant.shopifyVariantId.toString());
                matchingVariants.forEach((match) => {
                    const variant = match.variant;
                    const $variantElement = $(`.product__config-option-values-list .product__config-option-value .product__config-option-value-input[name="options[${variant.shopifyVariantId}]"]`).closest('.product__config-option-value');
                    if ($variantElement.length > 0) {
                        $variantElement.addClass('filtered').appendTo($list);
                    }
                });
                const $allVariantElements = $(`.product__config-option-values-list:not(.accessory-items) .product__config-option-value`);
                $allVariantElements.each(function() {
                    const $elem = $(this);
                    const variantId = $elem.find('.product__config-option-value-input').attr('name')?.match(/\[(\d+)\]/)?.[1];
                    if (variantId && !sortedVariantIds.includes(variantId)) {
                        $elem.removeClass('filtered').appendTo($list);
                    }
                });
            } else {
                console.log('No existing variant list found, creating new display...');
            }

            // Create variant option elements for the new display
            matchingVariants.forEach((match, index) => {
                const variant = match.variant;
                console.log(`Creating variant option ${index + 1}:`, variant.name, 'ID:', variant.shopifyVariantId);
                
                // Variant already has filter class from reordering above
                const isBestMatch = index === 0;
                
                const variantOption = $('<div>').addClass('variant-option').addClass(isBestMatch ? 'selected' : '').attr('data-variant-id', variant.shopifyVariantId);
                
                // Match indicator
                let matchText = '';
                let matchClass = 'match-indicator';
                
                // Handle match types from getMatchingVariants (required/optional) and legacy types
                if (match.matchType === 'required') {
                    matchText = 'Exact Match';
                    matchClass += ' exact-match';
                } else if (match.matchType === 'optional') {
                    matchText = 'Optional Match';
                    matchClass += ' medium-match';
                } else {
                    switch(match.matchType) {
                        case 'exact':
                            matchText = 'Exact Match';
                            matchClass += ' exact-match';
                            break;
                        case 'high_percentage':
                            matchText = `${Math.round(match.matchPercentage)}% Match`;
                            matchClass += ' high-match';
                            break;
                        case 'medium_percentage':
                            matchText = `${Math.round(match.matchPercentage)}% Match`;
                            matchClass += ' medium-match';
                            break;
                        default:
                            matchText = `${Math.round(match.matchPercentage)}% Match`;
                            matchClass += ' low-match';
                    }
                }
                    
                    const matchIndicator = $('<div>').addClass(matchClass).html(`
                        <span class="match-text">${matchText}</span>
                    `);
                    variantOption.append(matchIndicator);
                // }
                
                // Variant content
                const variantContent = $('<div>').addClass('variant-option-content');
                const variantTitle = $('<h4>').addClass('variant-option-title').text(variant.name);
                const variantSku = $('<div>').addClass('variant-option-sku').text(`SKU: ${variant.sku}`);
                const variantInventory = $('<div>').addClass('variant-option-inventory').text(`In Stock: ${variant.inventoryQuantity}`);
                
                variantContent.append(variantTitle, variantSku, variantInventory);
                
                // Variant image
                const variantImage = $('<div>').addClass('variant-option-image');
                const img = $('<img>').attr({
                    src: variant.image,
                    alt: variant.name,
                    width: '120',
                    height: '120'
                });
                variantImage.append(img);
                
                // Variant actions
                const variantActions = $('<div>').addClass('variant-option-actions');
                const quantityDiv = $('<div>').addClass('variant-option-quantity');
                const quantityLabel = $('<label>').addClass('variant-option-quantity-label').text('Quantity:');
                
                const quantityInput = $('<div>').addClass('quantity').attr('data-for-option', `quantity-${index}`);
                const minusBtn = $('<button>').addClass('quantity__button').attr('name', 'minus').text('-');
                const quantityField = $('<input>').addClass('quantity__input').attr({
                    type: 'number',
                    name: 'quantity',
                    value: '1',
                    min: '1',
                    step: '1'
                });
                const plusBtn = $('<button>').addClass('quantity__button').attr('name', 'plus').text('+');
                
                quantityInput.append(minusBtn, quantityField, plusBtn);
                quantityDiv.append(quantityLabel, quantityInput);
                variantActions.append(quantityDiv);
                
                // Add to cart/quote buttons
                const actionButtons = $('<div>').addClass('variant-action-buttons');
                const addToCartBtn = $('<button>').addClass('button button--primary variant-add-to-cart')
                    .attr('data-variant-id', variant.shopifyVariantId)
                    .attr('data-variant-index', index)
                    .text('ADD TO CART');
                const addToQuoteBtn = $('<button>').addClass('button button--ghost variant-add-to-quote')
                    .attr('data-variant-id', variant.shopifyVariantId)
                    .attr('data-variant-index', index)
                    .text('ADD TO QUOTE');
                
                actionButtons.append(addToCartBtn, addToQuoteBtn);
                variantActions.append(actionButtons);
                
                // Assemble variant option
                variantOption.append(variantImage, variantContent, variantActions);
                variantsList.append(variantOption);
                console.log(`  ✅ Variant option ${index + 1} appended to list`);
            });
            
            console.log(`Total variant options created: ${variantsList.children().length}`);
        } else {
            $(`.product__config-option-values-list:not(.accessory-items)`).removeClass('filter-list');
            // No matches found
            const noMatchMessage = $('<div>').addClass('no-match-message').html(`
                <div style="text-align: center; padding: 40px;">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                    </svg>
                    <h3>No Exact Matches Found</h3>
                    <p>We couldn't find an exact match for your configuration. Please contact us for custom pricing.</p>
                </div>
            `);
            variantsList.append(noMatchMessage);
        }
        
        variantDisplay.append(variantsList);
        
        // Footer actions
        const footerActions = $('<div>').addClass('variant-selection-actions');
        const clearButton = $('<button>').addClass('variant-clear-selection').text('Clear Selection');
        footerActions.append(clearButton);
        variantDisplay.append(footerActions);
        
        // Contact information
        const contactInfo = $('<div>').addClass('variant-selection-contact');
        //const contactText = $('<p>').html('Questions about this product? Call us at <a href="tel:4244002340">(424) 400-2340</a>');
        //contactInfo.append(contactText);
        variantDisplay.append(contactInfo);
        
        // Append to the container
        $('#attribute-form-container').after(variantDisplay);
        console.log('Variant display appended to DOM');
        
        // Show the variant selection
        variantDisplay.show();
        console.log('Variant display shown, children count:', variantDisplay.children().length);
        console.log('Variants list children count:', variantsList.children().length);
        
        // Initialize quantity controls
        initializeQuantityControls();
    }
    
    // Initialize quantity controls
    function initializeQuantityControls() {
      // Handle quantity increase
      $(document).on(
        "click",
        '.variant-option-quantity .quantity__button[name="plus"]',
        function () {
          const input = $(this).siblings(".quantity__input");
          const currentValue = parseInt(input.val()) || 1;
          input.val(currentValue + 1);
        }
      );

      // Handle quantity decrease
      $(document).on(
        "click",
        '.variant-option-quantity .quantity__button[name="minus"]',
        function () {
          const input = $(this).siblings(".quantity__input");
          const currentValue = parseInt(input.val()) || 1;
          if (currentValue > 1) {
            input.val(currentValue - 1);
          }
        }
      );
    }

    // Handle variant actions
    $(document).on("click", ".variant-add-to-cart", function () {
      const variantId = $(this).data("variant-id");
      const variantIndex = $(this).data("variant-index");
      const quantity = $(
        `.quantity[data-for-option="quantity-${variantIndex}"] .quantity__input`
      ).val();

      // Use the existing theme's add to cart functionality
      addVariantToCart(variantId, quantity);
    });

    $(document).on("click", ".variant-add-to-quote", function () {
      const variantId = $(this).data("variant-id");
      const variantIndex = $(this).data("variant-index");
      const quantity = $(
        `.quantity[data-for-option="quantity-${variantIndex}"] .quantity__input`
      ).val();

      // Use the existing theme's add to quote functionality
      addVariantToQuote(variantId, quantity);
    });

    $(document).on("click", ".variant-clear-selection", function () {
      // Reset form and show it again
      $(".variant-selection-display").remove();
      $("#attribute-form-container").show();
      $(".form-step").hide();
      $(".form-step:first-child").show();
      currentStep = 0;
      updateNavigationButtons();
      updateProgressBar();
      updateProgressStats();
    });

    // Popup "Add to Cart" and card quantity: add variant to cart via AJAX (so it works with attribute-form filtered list)
    $(document).on("click", ".popup-add-to-cart", function (e) {
      const variantId = $(this).data("variant-id");
      const $popupDetails = $(this).closest(".product__config-option-value-popup-details");
      const $qtyInput = $popupDetails.find(".popup-quantity");
      let quantity = $qtyInput.length ? parseInt($qtyInput.val(), 10) : 0;
      if (!quantity && variantId) {
        const $cardInput = $(`.product__config-option-values-list .quantity__input[name="quantity-${variantId}"]`);
        quantity = $cardInput.length ? parseInt($cardInput.val(), 10) : 0;
      }
      if (!variantId || !quantity || quantity <= 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert("Please set quantity (use + button) before adding to cart.");
        return false;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      $(this).addClass("loading").prop("disabled", true);
      addVariantToCart(variantId, quantity);
      const $btn = $(this);
      setTimeout(function () {
        $btn.removeClass("loading").prop("disabled", false);
        $btn.closest(".product__config-option-value-popup").removeClass("active");
      }, 1500);
      return false;
    });

    // Add variant to cart then refresh drawer the same way theme's cart.js onCartUpdate does
    function addVariantToCart(variantId, quantity) {
      var q = Math.max(1, parseInt(quantity, 10) || 1);
      var routes = window.routes || {};
      var cartAddUrl = routes.cart_add_url || "/cart/add.js";
      var cartUrl = routes.cart_url || "/cart";
      var cartDrawer = document.querySelector("cart-drawer");

      fetch(cartAddUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ id: String(variantId), quantity: q })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            throw new Error(data.description || data.message || "Could not add to cart");
          }
          console.log("Product added to cart successfully:", data);
          return fetch(cartUrl + "?section_id=cart-drawer", { headers: { "Accept": "text/html" } })
            .then(function (r) { return r.text(); })
            .then(function (htmlText) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(htmlText, "text/html");
              var selectors = ["cart-drawer-items", ".cart-drawer__footer"];
              for (var i = 0; i < selectors.length; i++) {
                var sel = selectors[i];
                var target = document.querySelector(sel);
                var source = doc.querySelector(sel);
                if (target && source) {
                  var node = document.importNode(source, true);
                  target.replaceWith(node);
                }
              }
              if (cartDrawer) {
                cartDrawer.classList.remove("is-empty");
                cartDrawer.open();
              }
              return data;
            });
        })
        .then(function (data) {
          if (typeof window.publish === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            try {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "attribute-form", cartData: data });
            } catch (e) {}
          }
          var cartSection = document.getElementById("shopify-section-cart-icon-bubble");
          if (cartSection && cartUrl) {
            fetch(cartUrl + "?section_id=cart-icon-bubble", { headers: { "Accept": "text/html" } })
              .then(function (r) { return r.text(); })
              .then(function (htmlText) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(htmlText, "text/html");
                var newSection = doc.querySelector("#shopify-section-cart-icon-bubble") || doc.querySelector(".shopify-section");
                if (newSection && cartSection.parentNode) {
                  var imported = document.importNode(newSection, true);
                  cartSection.parentNode.replaceChild(imported, cartSection);
                }
              })
              .catch(function () {});
          }
        })
        .catch(function (err) {
          console.error("Error adding to cart:", err);
          alert(err.message || "Error adding product to cart. Please try again.");
        });
    }
    
    // Add variant to quote using existing theme functionality
    function addVariantToQuote(variantId, quantity) {
        // Check if the theme has a quote functionality
        if (typeof window.addToQuote === 'function') {
            window.addToQuote(variantId, quantity);
        } else if (typeof window.addVariantToQuote === 'function') {
            window.addVariantToQuote(variantId, quantity);
        } else {
            // Fallback: show a message
            alert('Quote functionality not available. Please contact support.');
        }
    }
    
    // Detect and integrate with theme's cart functionality
    function detectThemeCartFunctions() {
        const themeFunctions = {
            addToCart: null,
            openCart: null,
            cartEvent: null
        };
        
        // Check for common theme cart function names
        const possibleCartFunctions = [
            'addToCart', 'addVariantToCart', 'addProductToCart',
            'openCart', 'toggleCart', 'showCart', 'openSideCart',
            'cartDrawer', 'cartSlideout', 'cartSidebar'
        ];
        
        possibleCartFunctions.forEach(funcName => {
            if (typeof window[funcName] === 'function') {
                console.log(`Found theme cart function: ${funcName}`);
                if (funcName.includes('add') || funcName.includes('cart')) {
                    themeFunctions.addToCart = funcName;
                } else if (funcName.includes('open') || funcName.includes('show') || funcName.includes('toggle')) {
                    themeFunctions.openCart = funcName;
                }
            }
        });
        
        // Check for cart-related events
        const cartEvents = ['cart:updated', 'cart:added', 'cart:opened', 'cart:toggled'];
        cartEvents.forEach(eventName => {
            if ($._data(document, 'events') && $._data(document, 'events')[eventName]) {
                themeFunctions.cartEvent = eventName;
                console.log(`Found theme cart event: ${eventName}`);
            }
        });
        
        // Check for cart drawer/sidebar elements
        const cartElements = [
            '.cart-drawer', '.cart-sidebar', '.cart-slideout', 
            '.cart-popup', '.cart-overlay', '[data-cart-drawer]'
        ];
        
        cartElements.forEach(selector => {
            if ($(selector).length) {
                console.log(`Found theme cart element: ${selector}`);
            }
        });
        
        return themeFunctions;
    }
    
    // Initialize theme cart integration
    const themeCart = detectThemeCartFunctions();
    console.log('Theme cart functions detected:', themeCart);
    
    // Store theme cart info globally for use in addVariantToCart
    window.themeCartFunctions = themeCart;

    // Initialize the form
    initAttributeForm().catch(function(error) {
        console.error('Failed to initialize attribute form:', error);
    });
});
